const tabDataArabic = [
  {
    id: 1,
    title: "الرعاية الصحية",
    slug: "healthcare",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن السادس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    bannerBtnText: "هيا بنا نبدأ",
    metaTitle: "خدمات تطوير البرمجيات للرعاية الصحية | حلول آمنة وقابلة للتوسع",
    metaDes:
      "قم ببناء برامج رعاية صحية متوافقة مع (إتش آي بي إيه إيه،) بما في ذلك تطبيقات التطبيب عن بعد وأنظمة السجلات الطبية الإلكترونية وبوابات المرضى. عزز تقديم الرعاية مع بتسكلان",
    description:
      "نقدم حلولًا مخصصة، مثل أنظمة السجلات الصحية الإلكترونية ومنصات إدارة المرضى، مما يعزز تقديم الرعاية والامتثال والكفاءة التشغيلية في قطاع الرعاية الصحية.",
    icon: "/images/heart.png",
    image: "healthcare.avif",
    bannerHeading: "بناء برمجيات الرعاية الصحية",
    bannerImage: "banner-image-industry.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/health-care.avif)",
    discriptionSection: {
      heading: "الابتكار التكنولوجي",
      discription:
        "يحدث ثورة في تفاعلات مقدمي الرعاية الصحية والمرضى، مما يمكّن المهنيين الطبيين من تقديم خدمات طبية فعالة من حيث التكلفة. من خلال الاستفادة من خدمات تطوير برامج الرعاية الصحية، يمكنك أتمتة العمليات، وتعزيز الكفاءة، وتحسين الجوانب التي تتراوح من إدارة بيانات المرضى إلى التأمين الطبي.",
      cardHeading: "شركة برمجيات الرعاية الصحية",
      cardDiscripiton:
        "تشهد صناعة الرعاية الصحية تغييرات حاسمة مع تغلغل كبير للتكنولوجيا الناشئة في كل من مقدمي الرعاية الصحية وقطاعات المرضى. حان الوقت الآن لتحويل أنظمتك الحالية إلى حلول قائمة على السحابة والتنقل وإنترنت الأشياء لأتمتة العمليات التجارية وإدارة بيانات الرعاية الصحية بكفاءة. بتسكلان هي شركة رائدة في تطوير برامج الرعاية الصحية تقدم استشارات تكنولوجية وتخصيص وتكامل وتحديث وصيانة برامج الرعاية الصحية. مع أكثر من 24 عامًا من الخبرة، لقد خدمنا بنجاح العديد من المنظمات، وساعدناهم على تحسين جودة الرعاية.",
    },
    statsSection: {
      backgroundImage: "healthcare-counter-bg.avif",
      heading: "قد مستقبل",
      greenPart: "الصحة الرقمية",
      discription:
        "تشجع بتسكلان شركات التكنولوجيا الصحية من خلال تطوير تطبيقات طبية مخصصة والاستفادة من كفاءتنا في HIPAA و HITECH و HAPI/FHIR و CoPay و eFax و OWASP و IEC 62443 و DICOM و ICD-10 و CPT.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "الرعاية الصحية",
      stats: [
        {
          count: "650+",
          text: "عقول خبيرة",
        },
        {
          count: "3000+",
          text: "عملاء عالميون",
        },
        {
          count: "4200+",
          text: "مشاريع ناجحة",
        },
        {
          count: "93%",
          text: "معدل الاحتفاظ بالعملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات الرعاية الصحية",
      text: "تتضمن خدمات تطوير برمجيات الرعاية الصحية تصميم وتطوير وتنفيذ حلول برمجية مخصصة لتعزيز رعاية المرضى وتحسين سير عمل المستشفى. تقدم بتسكلان خدمات وحلول برمجيات الرعاية الصحية الشاملة لمنظمات الرعاية الصحية والأطباء والعيادات والمستشفيات والشركات الناشئة في مجال الصحة الرقمية والبنى التحتية للأجهزة الطبية.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "تطوير برمجيات EMR و EHR",
          text: "ينشئ مطورونا الخبراء أنظمة EMR و EHR مخصصة، مما يساعد مقدمي الرعاية الصحية على إدارة بيانات المرضى، وتحسين تنسيق الرعاية، وتبسيط سير العمل لتجربة مريض سلسة.",
          btnLink: "#",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "تطوير تطبيقات طبية مخصصة",
          text: "نقوم بتصميم تطبيقات طبية مخصصة لتعزيز رعاية المرضى وتبسيط عمليات المستشفى. تتوافق تطبيقاتنا مع HIPAA وتدعم الجدولة والمراسلة وإدارة الوصفات الطبية.",
          btnLink: "#",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          heading: "تطوير منصات التطبيب عن بعد",
          text: "تربط منصاتنا للتطبيب عن بعد المتخصصين في الرعاية الصحية والمرضى عن بعد. من خلال مكالمات الفيديو الآمنة وحجز المواعيد وتتبع التاريخ الطبي، نجعل الرعاية الصحية متاحة من أي مكان.",
          btnLink: "#",
          image: "image.png",
        },
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "أنظمة إدارة المرضى",
          text: "نقوم بإنشاء أنظمة لإدارة بيانات المرضى والمواعيد والفواتير بكفاءة. تعمل حلولنا على تحسين كفاءة سير العمل وتقليل المهام الإدارية وتعزيز رعاية المرضى بشكل عام.",
          btnLink: "#",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "برنامج الفواتير الطبية",
          text: "نقوم بتطوير برامج الفواتير الطبية لتبسيط الفواتير ومطالبات التأمين ومعالجة الدفع. تضمن حلولنا الدقة وتبسيط العمليات المالية ودعم الامتثال للوائح.",
          btnLink: "#",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير وشهادات أمان برمجيات الرعاية الصحية التي نعمل بها",
      discription:
        "حماية بيانات عملائنا وأمنهم وامتثال المنتج هي أهم أولوياتنا؛ ولهذا السبب، بصفتنا شركة رائدة في تطوير تطبيقات الرعاية الصحية، فإننا نلتزم بمعايير وشهادات أمان صارمة في مجال الرعاية الصحية. كما أن حلول برامج الرعاية الصحية لدينا ستكون متوافقة تمامًا مع المعايير الصحية الوطنية والإقليمية والصناعية. يقوم مستشارو تكنولوجيا المعلومات في مجال الرعاية الصحية لدينا بإجراء مسح للثغرات الأمنية باستخدام منهجية OWASP واختبار الاختراق وفحص أمان البرامج والامتثال من خلال عمليات التدقيق.",
      image: "health-care-software-image.avif",
    },
    softwareSolutions: {
      heading: "اكتشف حلول برمجيات الرعاية الصحية لدينا",
      discription:
        "تم تصميم حلول برمجيات الرعاية الصحية من بتسكلان لتلبية الاحتياجات المحددة لصناعة الرعاية الصحية لتقديم رعاية فعالة وشخصية وعالية الجودة. تمكن من اتخاذ القرارات المستندة إلى البيانات وتحويل عملية إدارة الرعاية الصحية باستخدام حلول برامج الرعاية الصحية المناسبة.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "نظام إدارة علاقات العملاء للرعاية الصحية",
          text: "يمكن لبرنامج إدارة علاقات العملاء الشامل لدينا للرعاية الصحية أتمتة عملياتك الطبية، وتحسين رحلة المريض، ومساعدتك في إدارة بوابة المرضى بفعالية.",
        },
        {
          id: 2,
          heading: "حلول تحليلات الرعاية الصحية",
          text: "يساعد برنامج تحليلات الرعاية الصحية الخاص بنا عملك بتحليل دقيق للبيانات يحسن سرعة اتخاذ القرار ويمنح المستخدمين القدرة على إعداد البيانات دون كتابة أي رمز.",
        },
        {
          id: 3,
          heading: "برنامج إدارة المستشفيات",
          text: "يساعدك نظام إدارة المستشفيات (HMS) الخاص بنا على الوصول إلى بيانات المرضى وإدارتها بفعالية وإنشاء سجلات متعددة بناءً على متطلباتك - الموقع والجنس والعمر وما إلى ذلك.",
        },
        {
          id: 4,
          heading: "منصة مشاركة المرضى",
          text: "تمكّن حلول مشاركة المرضى لدينا المرضى من إدارة معلوماتهم الصحية بشكل استباقي، والتواصل مع الخبراء، وتحديد المواعيد، والمشاركة في خطط العلاج.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: تطوير برمجيات الرعاية الصحية المتطورة",
      discription:
        "يستفيد مهندسو برمجيات الرعاية الصحية لدينا على أفضل وجه من التقنيات المبتكرة لتقديم خدمات تطوير حلول رعاية صحية أكثر ذكاءً.",
      accordionData: [
        {
          id: "collapseOne",
          title: "حلول البلوكتشين",
          content:
            "تضمن خدمات برامج الرعاية الصحية القائمة على البلوكتشين لدينا النقل الآمن للسجلات الصحية والتجارب السريرية بين سلاسل الكتل الخاصة لاستثمار قوي طويل الأجل. نحن نلتزم بمعايير الصناعة وبروتوكولات الأمان.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "الذكاء الاصطناعي والتعلم الآلي",
          content:
            "استغل قوة الذكاء الاصطناعي والتعلم الآلي لتعزيز اتخاذ القرار، وأتمتة المهام، وتقديم حلول رعاية صحية ذكية. توفر خوارزمياتنا المتقدمة رؤى قابلة للتنفيذ مصممة خصيصًا لاحتياجاتك.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "التقنيات الغامرة (الواقع الافتراضي/المعزز/المختلط)",
          content:
            "استفد من الواقع الافتراضي والمعزز والمختلط لتحويل رعاية المرضى والتدريب والتشخيص بتجارب غامرة ومتطورة.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "أتمتة العمليات الروبوتية (RPA)",
          content:
            "تبسيط المهام المتكررة وتحسين العمليات باستخدام RPA، مما يتيح كفاءة ودقة أكبر في سير عمل الرعاية الصحية.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة المتداولة",
      discription:
        "ابحث عن إجابات الخبراء للأسئلة الشائعة حول خدمات تطبيقات الويب للرعاية الصحية، بما في ذلك النشر والفوائد وأفضل الممارسات.",
      faqData: [
        {
          id: "collapseOne",
          question:
            "لماذا يعد تطوير البرمجيات المخصصة أمرًا بالغ الأهمية لمرافق الرعاية الصحية؟",
          answer:
            "تساعد البرامج المخصصة مرافق الرعاية الصحية على تلبية احتياجات محددة، وتعزيز العمليات، وتقديم رعاية جيدة للمرضى.",
        },
        {
          id: "collapseTwo",
          question: "ماذا تفعل شركات تطوير برمجيات الرعاية الصحية؟",
          answer:
            "يقومون بتصميم وتطوير وتنفيذ برامج مخصصة لتبسيط عمليات الرعاية الصحية وتحسين الكفاءة.",
        },
        {
          id: "collapseThree",
          question:
            "ما أنواع حلول تطوير برمجيات الرعاية الصحية المخصصة المتاحة؟",
          answer:
            "تشمل الحلول أنظمة السجلات الصحية الإلكترونية، ومنصات التطبيب عن بعد، وبوابات المرضى، وأدوات التحليلات.",
        },
        {
          id: "fourth",
          question: "كيف تختلف برامج الرعاية الصحية المخصصة عن الحلول الجاهزة؟",
          answer:
            "توفر البرامج المخصصة ميزات مخصصة وقابلية للتوسع وخيارات تكامل لتلبية احتياجات العمل الفريدة.",
        },
        {
          id: "fifth",
          question:
            "هل يمكن تعديل أو توسيع برامج الرعاية الصحية المخصصة المنفذة بعد نشرها؟",
          answer:
            "نعم، يمكن تحديث البرامج المخصصة أو توسيعها للتكيف مع المتطلبات والتقنيات المتطورة.",
        },
      ],
    },
  },

  // {
  //   id: 2,
  //   metaTitle:
  //     "خدمات تطوير برمجيات التكنولوجيا المالية | حلول مالية من الجيل التالي",
  //   metaDes:
  //     "استفد من برمجيات التكنولوجيا المالية المتقدمة للمحافظ الرقمية وبوابات الدفع وحلول البلوكتشين. قم ببناء تطبيقات مالية آمنة ومبتكرة مع بتسكلان",
  //   content:
  //     "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن السادس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
  //   title: "التكنولوجيا المالية",
  //   slug: "fintech",
  //   bannerBtnText: "هيا بنا نبدأ",
  //   bannerHeading: "بناء برمجيات التكنولوجيا المالية",
  //   description:
  //     "تزدهر التكنولوجيا المالية بالابتكار، ونحن هنا لدفعها إلى الأمام. تطبيقات الويب لدينا تبسط العمليات المالية المعقدة، من أنظمة الدفع الآمنة إلى أدوات التخطيط المالي. إنها مصممة لتمكين الشركات، وتعزيز تجارب العملاء، والحفاظ على كل شيء آمنًا على طول الطريق.",
  //   icon: "/images/Fintech.png",
  //   smallIcon: "Fintech-logo.png",
  //   image: "fintech.png",
  //   bannerImage: "fintech-detail-banner.png",
  //   backgroundImage: "url(/images/industry-detial-banner-bg/Fintech.png)",
  //   discriptionSection: {
  //     heading: "خبرة برمجيات التكنولوجيا المالية",
  //     discription:
  //       "نقدم حلولًا مبتكرة للتكنولوجيا المالية، بما في ذلك بوابات الدفع الآمنة، ومنصات الخدمات المصرفية المخصصة، والمستشارين الآليين، والبلوكتشين للمعاملات الشفافة، واكتشاف الاحتيال المدعوم بالذكاء الاصطناعي. عزز عملياتك المالية بتقنية آمنة وفعالة وموثوقة.",
  //     cardHeading: "تحويل الخدمات المالية باستخدام التكنولوجيا المتطورة",
  //     cardDiscripiton:
  //       "تُحدث ثورة التكنولوجيا المالية تحولًا في كيفية تفاعل الأفراد والشركات مع الخدمات المالية، وتقدم حلولًا سلسة وفعالة وآمنة. من المدفوعات الرقمية إلى اكتشاف الاحتيال المدعوم بالذكاء الاصطناعي ومنصات الاستثمار المتقدمة، تبسط ابتكاراتنا العمليات وتعزز تجارب المستخدم. احتضن التكنولوجيا المتطورة لإعادة تعريف خدماتك المالية وبناء الثقة وفتح فرص نمو جديدة.",
  //   },
  //   statsSection: {
  //     backgroundImage: "Fintech-counter.jpeg",
  //     heading: "قد مستقبل",
  //     greenPart: "التمويل الرقمي",
  //     discription:
  //       "عزز أعمالك بحلول التكنولوجيا المالية المتطورة المصممة لتبسيط العمليات، وتعزيز الأمان، وإعادة تعريف التجارب المالية. ابق في المقدمة في المشهد المالي الرقمي المتطور.",
  //     subheading: "أفضل شركة استشارية في مجال",
  //     greenPartSubHeading: "التكنولوجيا المالية",
  //     stats: [
  //       {
  //         count: "650+",
  //         text: "مشروع تم تسليمه في القطاع المالي",
  //       },
  //       {
  //         count: "300+",
  //         text: "مؤسسة مالية راضية",
  //       },
  //       {
  //         count: "2500+",
  //         text: "ميزة مخصصة تم نشرها",
  //       },
  //       {
  //         count: "95%",
  //         text: "معدل رضا العملاء",
  //       },
  //     ],
  //   },
  //   industryServices: {
  //     heading: "خدمات تطوير برمجيات التكنولوجيا المالية",
  //     text: "عزز أعمالك بحلول برمجيات التكنولوجيا المالية المتطورة المصممة لتعزيز الأمان والكفاءة وتجارب المستخدم. حول العمليات المالية بتقنية مدفوعة بالابتكار.",
  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "حلول الخدمات المصرفية الرقمية",
  //         text: "تطوير منصات مصرفية عبر الإنترنت سهلة الاستخدام وآمنة وغنية بالميزات ومصممة لتلبية احتياجات المؤسسات المالية الحديثة وعملائها.",
  //         btnLink: "#",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "أنظمة معالجة الدفع",
  //         text: "تنفيذ بوابات دفع رقمية سلسة وفعالة وآمنة لدعم المعاملات الخالية من المتاعب وتعزيز ثقة المستخدم في خدماتك.",
  //         btnLink: "#",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/machine-learning.png",
  //         heading: "تطوير البلوكتشين والعملات المشفرة",
  //         text: "استفد من تقنية البلوكتشين لإنشاء أنظمة شفافة وغير مركزية تدفع الابتكار وتوفر حلولًا آمنة وقابلة للتطوير للعملات المشفرة.",
  //         btnLink: "#",
  //         image: "image.png",
  //       },
  //     ],
  //   },
  //   industryAdvertising: {
  //     heading: "معايير ولوائح الأمن المالي التي نلتزم بها",
  //     discription:
  //       "في القطاع المالي، يعد الأمن والثقة ضروريين. نحن نلتزم بالمعايير العالمية مثل PCI DSS، مما يضمن أعلى مستوى من حماية بيانات الدفع، و GDPR لخصوصية البيانات القوية، و ISO 27001 لإدارة أمن المعلومات الشاملة. تساعدك خبرتنا على البقاء في صدارة التحديات التنظيمية، وتقديم حلول التكنولوجيا المالية الآمنة والمتوافقة التي تلهم الثقة بين المستخدمين لديك. شاركنا في منصات مالية موثوقة ومتوافقة مع اللوائح تلبي متطلبات الاقتصاد الرقمي اليوم.",
  //     image: "Fintech-add.jpg",
  //   },
  //   softwareSolutions: {
  //     heading: "اكتشف حلول برمجيات التكنولوجيا المالية لدينا",
  //     discription:
  //       "تم تصميم حلول برمجيات الرعاية الصحية من Bitsclan لتلبية الاحتياجات المحددة لصناعة الرعاية الصحية لتقديم رعاية فعالة وشخصية وعالية الجودة. تمكن من اتخاذ القرارات المستندة إلى البيانات وتحويل عملية إدارة الرعاية الصحية باستخدام حلول برامج الرعاية الصحية المناسبة.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "المحافظ الرقمية",
  //         text: "تطوير حلول محافظ رقمية آمنة وسهلة الاستخدام وغنية بالميزات مصممة لتخزين وإدارة ومعالجة العملات الرقمية بسهولة وموثوقية.",
  //       },
  //       {
  //         id: 2,
  //         heading: "منصات تداول الأسهم",
  //         text: "إنشاء منصات مخصصة مجهزة بأدوات متقدمة لتمكين تجارب تداول واستثمار سلسة وفعالة وآمنة للمستخدمين.",
  //       },
  //       {
  //         id: 3,
  //         heading: "أنظمة إدارة القروض",
  //         text: "تصميم أنظمة شاملة ومبسطة لإدارة عمليات القروض بكفاءة، من التقديم والصرف إلى تتبع السداد والتسويات.",
  //       },
  //       {
  //         id: 4,
  //         heading: "حلول تكنولوجيا التأمين",
  //         text: "تطوير حلول مبتكرة لأتمتة وتحسين وتعزيز عمليات التأمين المختلفة، مما يحسن الكفاءة ورضا العملاء.",
  //       },
  //     ],
  //   },
  //   industryExpertise: {
  //     heading: "خبرتنا: تطوير برمجيات التكنولوجيا المالية الرائدة",
  //     discription:
  //       "نصنع حلولًا تكنولوجية مالية ذكية، مع التركيز على التطبيقات الآمنة، والمحافظ الرقمية، والبلوكتشين، وبوابات الدفع لتبسيط عالمك المالي.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "حلول البلوكتشين",
  //         content:
  //           "تضمن حلول التكنولوجيا المالية المدعومة بالبلوكتشين لدينا معاملات آمنة وشفافة، مما يوفر أساسًا موثوقًا للمحافظ الرقمية وأدوات الاستثمار وبوابات الدفع الآمنة، مما يعزز ثقة العملاء.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "تطوير المحافظ الرقمية",
  //         content:
  //           "نقوم بإنشاء محافظ رقمية آمنة وسهلة الاستخدام تتيح المدفوعات السلسة وإدارة العملات المشفرة. تعطي حلولنا الأولوية للسلامة وسهولة الاستخدام لكل من المستهلكين والشركات.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "تكامل بوابة الدفع",
  //         content:
  //           "تعمل خدمات بوابة الدفع لدينا على تبسيط المعاملات عبر الإنترنت، مما يضمن معالجة دفع آمنة وفعالة. نحن ندمج بروتوكولات أمان قوية لحماية البيانات المالية الحساسة في الوقت الفعلي.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "حلول الأمن المالي",
  //         content:
  //           "نقدم حلولًا أمنية متطورة لحماية التطبيقات المالية. من تشفير البيانات الآمن إلى منع الاحتيال، تحمي أنظمتنا المعاملات المالية ومعلومات العملاء.",
  //       },
  //     ],
  //   },
  //   industryFaqs: {
  //     heading: "الأسئلة المتداولة",
  //     discription: "عالج المخاوف الشائعة مثل",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question: "ما هي التقنيات المستخدمة في تطوير التكنولوجيا المالية؟",
  //         answer:
  //           "نحن نستفيد من التقنيات المتطورة مثل البلوكتشين، والذكاء الاصطناعي (AI)، والتعلم الآلي (ML)، والحوسبة السحابية، وتحليلات البيانات الكبيرة لبناء حلول تكنولوجيا مالية آمنة ومبتكرة. تعزز هذه التقنيات الكفاءة وقابلية التوسع وتجربة المستخدم.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "كيف تضمنون أمن البيانات والامتثال؟",
  //         answer:
  //           "نحن نلتزم بمعايير الأمن المعترف بها عالميًا مثل PCI DSS و ISO 27001 و GDPR. بالإضافة إلى ذلك، ننفذ بروتوكولات تشفير متقدمة، ومصادقة متعددة العوامل، وعمليات تدقيق أمنية منتظمة لحماية البيانات المالية الحساسة.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question: "هل يمكنكم التكامل مع أنظمة البنوك الحالية؟",
  //         answer:
  //           "نعم، نحن متخصصون في دمج الحلول الحديثة مع أنظمة البنوك القديمة باستخدام واجهات برمجة التطبيقات (APIs)، والبرمجيات الوسيطة، وغيرها من البروتوكولات الآمنة. تضمن عمليات التكامل السلس لدينا الحد الأدنى من التعطيل مع تعزيز وظائف النظام.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "كم من الوقت يستغرق تطوير حل تكنولوجيا مالية؟",
  //         answer:
  //           "يعتمد الجدول الزمني للتطوير على تعقيد ونطاق مشروعك. في المتوسط، قد يستغرق حل التكنولوجيا المالية المخصص 3-6 أشهر، ولكن يمكن تطوير الميزات الأصغر أو المنتجات ذات الحد الأدنى من الميزات (MVPs) بسرعة أكبر.",
  //       },
  //       {
  //         id: "fifth",
  //         question: "هل تقدمون دعم ما بعد التطوير؟",
  //         answer:
  //           "بالتأكيد! نحن نقدم دعمًا شاملاً بعد التطوير، بما في ذلك الصيانة الدورية، وتحديثات الميزات، وتصحيحات الأمان، والمساعدة الفنية على مدار الساعة طوال أيام الأسبوع لضمان التشغيل السلس لحل التكنولوجيا المالية الخاص بك.",
  //       },
  //     ],
  //   },
  // },

  {
    id: 3,
    metaTitle:
      "خدمات تطوير البرمجيات المخصصة للبيع بالتجزئة | حقق النجاح في قطاع التجزئة",
    metaDes:
      "يجب أن يكون التسوق عبر الإنترنت سلسًا، وتطبيقات الويب الخاصة بنا تضمن ذلك. من تجارب التسوق المخصصة إلى إدارة المخزون المتقدمة، نساعد الشركات على التواصل مع العملاء، وزيادة مبيعاتها، وإنشاء انطباعات دائمة.",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن السادس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    title: "التجزئة والتجارة الإلكترونية",
    slug: "retail-ecommerce",
    description:
      "نحن ندعم تجار التجزئة بأنظمة إدارة المخزون، وتجارب التسوق المخصصة، ومنصات متعددة القنوات تعزز المبيعات وولاء العملاء.",
    icon: "/images/ecommerce-icon.png",
    image: "ecommerce.avif",
    bannerBtnText: "هيا بنا نبدأ",
    bannerHeading: "بناء برمجيات التجزئة والتجارة الإلكترونية",
    bannerImage: "ecommerce-detail-banner.png",
    backgroundImage:
      "url(/images/industry-detial-banner-bg/Retail-ecommerce.avif)",
    discriptionSection: {
      heading:
        "تحويل التجزئة والتجارة الإلكترونية باستخدام التكنولوجيا المبتكرة",
      discription:
        "تتطور صناعات التجزئة والتجارة الإلكترونية بسرعة، مدفوعة بتوقعات العملاء والتحول الرقمي. من تجارب التسوق المخصصة إلى إدارة سلسلة التوريد الفعالة، تمكّن حلولنا الشركات من التكيف والنمو والنجاح في سوق تنافسية.",
      cardHeading: "خبرة في التجزئة والتجارة الإلكترونية",
      cardDiscripiton:
        "نقدم حلولًا شاملة للتجارة الإلكترونية مصممة للارتقاء بأعمالك. توفر منصاتنا متعددة القنوات تجربة تسوق سلسة عبر جميع الأجهزة، بينما تدفع توصيات المنتجات المدعومة بالذكاء الاصطناعي مشاركة شخصية. من خلال إدارة المخزون والطلبات الفعالة، والتتبع في الوقت الفعلي، وتكامل الدفع السلس، نضمن معاملات سلسة وآمنة. توفر تحليلات البيانات المتقدمة لدينا رؤى قيمة حول سلوك العملاء، مما يتيح اتخاذ قرارات أكثر ذكاءً ويعزز نمو الأعمال.",
    },
    statsSection: {
      backgroundImage: "ecommerce-counter-bg.avif",
      heading: "حوّل عملك في",
      greenPart: "التجارة الإلكترونية",
      discription:
        "نقدم حلولًا ذكية لتبسيط متجرك عبر الإنترنت، وتحسين الأمان، وتعزيز أنظمة الدفع، مما يساعدك على البقاء في الطليعة في عالم التسوق الرقمي سريع التطور.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "التجزئة والتجارة الإلكترونية",
      stats: [
        {
          count: "800+",
          text: "مشروع تم تسليمه في التجزئة والتجارة الإلكترونية",
        },
        {
          count: "500+",
          text: "علامة تجارية راضية في مجال التجزئة",
        },
        {
          count: "10,000+",
          text: "ميزة مخصصة تم نشرها",
        },
        {
          count: "97%",
          text: "معدل رضا العملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات التجزئة والتجارة الإلكترونية",
      text: "تنشئ خدمات تطوير برمجيات التجزئة والتجارة الإلكترونية لدينا حلولًا مخصصة وقابلة للتطوير تعزز تجارب العملاء وتبسط العمليات. نبني منصات آمنة تدفع النمو والنجاح في السوق الرقمية.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "منصات التجارة الإلكترونية المخصصة",
          text: "تطوير منصات تجارة إلكترونية قابلة للتوسع وغنية بالميزات مصممة خصيصًا لتلبية احتياجات عملك الفريدة، وتوفر تجربة تسوق مثالية لعملائك.",
          btnLink: "#",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "حلول التجارة عبر الهاتف المحمول",
          text: "إنشاء حلول تجارة عبر الهاتف المحمول سلسة وآمنة توفر تكاملًا سلسًا للمدفوعات الرقمية، مما يعزز تجربة المستخدم والثقة عبر جميع منصات الهاتف المحمول.",
          btnLink: "#",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          heading: "نقاط البيع وإدارة المخزون",
          text: "تحسين عمليات البيع بالتجزئة الخاصة بك باستخدام أنظمة نقاط البيع وإدارة المخزون القوية، المصممة لتبسيط تتبع المخزون وإدارة الطلبات والتحليلات في الوقت الفعلي.",
          btnLink: "#",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير أمان التجزئة والتجارة الإلكترونية التي نلتزم بها",
      discription:
        "نحن نلتزم بأعلى معايير أمان التجزئة والتجارة الإلكترونية لضمان حماية بيانات العملاء والمعاملات. تتوافق حلولنا مع PCI DSS و GDPR و ISO 27001، وهي مصممة للحماية من التهديدات والحفاظ على الثقة عبر جميع المنصات الرقمية.",
      image: "ecommerce-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول التجزئة والتجارة الإلكترونية لدينا",
      discription:
        "اكتشف حلول التجزئة والتجارة الإلكترونية المبتكرة المصممة لتعزيز النمو وتحسين تجارب العملاء وتبسيط العمليات من خلال منصات آمنة وقابلة للتطوير وتكامل سلس.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "منصات متعددة القنوات",
          text: "توحيد التجارب عبر الإنترنت وفي المتاجر لتقديم رحلة عميل سلسة عبر جميع نقاط الاتصال، مما يضمن مشاركة متسقة وشخصية.",
        },
        {
          id: 2,
          heading: "تطوير سوق مخصص",
          text: "إنشاء منصات مصممة خصيصًا تربط البائعين والمشترين، وتوفر بيئة آمنة وفعالة للمعاملات ونمو الأعمال.",
        },
        {
          id: 3,
          heading: "حلول اللوجستيات وسلسلة التوريد",
          text: "تحسين عمليات التسليم من خلال التتبع والأتمتة في الوقت الفعلي، مما يضمن شحنات أسرع وأكثر موثوقية وتحسين الكفاءة التشغيلية.",
        },
        {
          id: 4,
          heading: "برامج ولاء العملاء",
          text: "إشراك العملاء بمكافآت وعروض مخصصة تدفع الأعمال المتكررة وتقوي ولاء العلامة التجارية من خلال حوافز مستهدفة.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول التجزئة والتجارة الإلكترونية المتطورة",
      discription:
        "نحن متخصصون في صياغة منصات مبتكرة وآمنة وقابلة للتطوير تعزز مشاركة العملاء وتدفع نمو الأعمال في قطاعات التجزئة والتجارة الإلكترونية.",
      accordionData: [
        {
          id: "collapseOne",
          title: "تجارب تسوق سلسة",
          content:
            "دمج كل من القنوات عبر الإنترنت وغير المتصلة لتقديم رحلة تسوق سلسة وشخصية عبر جميع نقاط اتصال العملاء، مما يضمن الرضا في كل خطوة.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "حلول السوق المخصصة",
          content:
            "تصميم منصات مخصصة تربط المشترين والبائعين بأنظمة معاملات آمنة وفعالة، مما يعزز التجارة السلسة وتوسع الأعمال.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "مشاركة العملاء المخصصة",
          content:
            "تعزيز ولاء العملاء من خلال المكافآت والعروض والحوافز المخصصة، وتحويل المتسوقين لمرة واحدة إلى عملاء متكررين وتعزيز العلاقات طويلة الأمد.",
        },
      ],
    },
    industryFaqs: {
      heading: "التجزئة والتجارة الإلكترونية: الأسئلة الشائعة",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات التجزئة والتجارة الإلكترونية لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question:
            "ما هي التقنيات التي تستخدمونها لبناء منصات التجارة الإلكترونية؟",
          answer:
            "نحن نستخدم أطر عمل وأدوات حديثة مثل Shopify و Magento و WooCommerce و ReactJS و NodeJS لإنشاء منصات عالية الأداء. بالإضافة إلى ذلك، ندمج الحلول السحابية للقابلية للتوسع والموثوقية.",
        },
        {
          id: "collapseTwo",
          question:
            "هل يمكنكم دمج أدوات الجهات الخارجية مثل أنظمة إدارة علاقات العملاء (CRMs) وأنظمة تخطيط موارد المؤسسات (ERPs)؟",
          answer:
            "نعم، نحن متخصصون في دمج أدوات مثل Salesforce و Zoho CRM و SAP و Oracle ERP في منصات التجارة الإلكترونية لتبسيط العمليات التجارية وتحسين الكفاءة.",
        },
        {
          id: "collapseThree",
          question: "كيف تضمنون المعاملات السريعة والآمنة؟",
          answer:
            "ننفيذ تشفير SSL/TLS، و الترميز، و الامتثال لمعيار PCI DSS لحماية المعاملات. بالإضافة إلى ذلك، نقوم بتحسين المنصات لسرعات تحميل سريعة، مما يضمن تجربة دفع سلسة.",
        },
        {
          id: "fourth",
          question:
            "هل تقدمون تطوير تطبيقات الهاتف المحمول للتجارة الإلكترونية؟",
          answer:
            "نعم، نقوم بتصميم وتطوير تطبيقات الهاتف المحمول لنظامي iOS و android، مما يضمن تجربة تسوق سريعة الاستجابة وجذابة عبر الأجهزة.",
        },
        {
          id: "fifth",
          question: "كيف تتعاملون مع إدارة المخزون والطلبات؟",
          answer:
            "نقوم بتطوير أنظمة توفر تتبعًا للمخزون في الوقت الفعلي، وإعادة الطلب تلقائيًا، وإدارة تنفيذ الطلبات، مما يضمن عمليات فعالة لكل من الشركات الصغيرة والكبيرة.",
        },
        {
          id: "sixth",
          question: "هل يمكنكم مساعدتنا في إنشاء سوق مخصص؟",
          answer:
            "بالتأكيد! نحن متخصصون في تطوير أسواق متعددة البائعين مصممة خصيصًا لاحتياجات عملك، مع ميزات مثل لوحات تحكم البائعين، وتقسيم الدفع، وإدارة كتالوج المنتجات.",
        },
      ],
    },
  },

  {
    id: 4,
    metaTitle: "تطوير برمجيات العقارات | تحويل إدارة الممتلكات",
    metaDes:
      "لم يكن العثور على العقارات وإدارتها أسهل من أي وقت مضى. باستخدام تطبيقات الويب الخاصة بنا، يمكنك تقديم جولات افتراضية، وإدارة علاقات العملاء، ومساعدة المشترين والبائعين على الاتصال بسلاسة. نبني أدوات تجعل المتخصصين في مجال العقارات متقدمين بخطوة واحدة.",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن السادس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    title: "العقارات",
    slug: "real-estate",
    description:
      "نحن نقدم للمتخصصين في مجال العقارات أنظمة إدارة الممتلكات، ومنصات إدارة علاقات العملاء، وحلول المعاملات الآمنة لتبسيط العمليات وتحسين تفاعلات العملاء.",
    icon: "/images/RealEstate.png",
    image: "realestate.png",
    bannerBtnText: "هيا بنا نبدأ",
    bannerHeading: "بناء برمجيات العقارات",
    bannerImage: "realestate-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/RealEstate.avif)",
    discriptionSection: {
      heading: "تحويل العقارات باستخدام التكنولوجيا المتطورة",
      discription:
        "تشهد صناعة العقارات تحولًا رقميًا لتبسيط إدارة الممتلكات، وزيادة المبيعات، وتحسين تفاعلات العملاء. تساعد حلولنا العقارية المخصصة الشركات على تحديث عملياتها، وتعزيز الرؤية، وإنشاء تجارب عملاء سلسة.",
      cardHeading: "خبرة تكنولوجيا العقارات",
      cardDiscripiton:
        "نحن نقدم حلولًا عقارية مبتكرة، بما في ذلك بوابات قوائم العقارات الديناميكية، وجولات افتراضية غامرة، وتكامل سلس لإدارة علاقات العملاء. تعمل أنظمة توليد العملاء المتوقعين التلقائية وأنظمة المعاملات الآمنة عبر الإنترنت على تبسيط العمليات وتحسين تجارب العملاء. استفد من التكنولوجيا المتطورة لتعزيز الكفاءة ودفع النمو في أعمالك العقارية.",
    },
    statsSection: {
      backgroundImage: "realestate-counter-bg.avif",
      heading: "قد مستقبل",
      greenPart: "تكنولوجيا العقارات",
      discription:
        "نحن نساعد عملك على الازدهار من خلال أدوات سهلة الاستخدام لإدارة الممتلكات، وبوابات العقارات، والجولات الافتراضية، وأنظمة إدارة علاقات العملاء لتعزيز القوائم وتوليد العملاء المحتملين.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "العقارات",
      stats: [
        {
          count: "600+",
          text: "مشروع تم تسليمه في قطاع العقارات",
        },
        {
          count: "400+",
          text: "وكالة ومطور راضين",
        },
        {
          count: "5,000+",
          text: "ميزة مخصصة تم نشرها",
        },
        {
          count: "95%",
          text: "معدل الاحتفاظ بالعملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات العقارات",
      text: "نحن نقدم حلول برمجيات عقارية مخصصة تعمل على تحسين إدارة الممتلكات، وتعزيز مشاركة العملاء، ودفع الكفاءة عبر العمليات.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "أنظمة إدارة الممتلكات",
          text: "تبسيط المهام مثل إدارة المستأجرين، وتحصيل الإيجارات، وجدولة الصيانة باستخدام أنظمة إدارة الممتلكات المخصصة والمصممة لتلبية احتياجات عملك.",
          btnLink: "#",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "حلول الجولات الافتراضية",
          text: "أضف الحياة إلى العقارات من خلال جولات افتراضية بزاوية 360 درجة ونمذجة ثلاثية الأبعاد، مما يوفر تجربة غامرة للمشترين أو المستأجرين المحتملين.",
          btnLink: "#",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          heading: "أنظمة إدارة علاقات العملاء للعقارات",
          text: "تمكين الوكلاء من خلال أنظمة إدارة علاقات العملاء القوية لتتبع العملاء المتوقعين، وإدارة خطوط الأنابيب، والمتابعات التلقائية، وتحسين عمليات العقارات.",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير أمن البيانات والامتثال العقاري",
      discription:
        "يعد ضمان أمن البيانات في العقارات أمرًا بالغ الأهمية. نحن نلتزم بمعايير حماية البيانات العالمية مثل GDPR و SOC 2 و ISO 27001. تحمي إجراءات الأمان المتقدمة لدينا معلومات العميل الحساسة، مما يتيح معاملات الممتلكات الآمنة وأنظمة إدارة المستأجرين.",
      image: "realestate-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برمجيات العقارات لدينا",
      discription:
        "اكتشف حلول برمجيات العقارات المبتكرة المصممة لتبسيط العمليات، وتعزيز تفاعلات العملاء، ودفع نمو الأعمال.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "بوابات العقارات",
          text: "بناء بوابات غنية بالميزات لقوائم العقارات، وقدرات بحث متقدمة، وتجارب حجز سلسة.",
        },
        {
          id: 2,
          heading: "أنظمة إدارة الوكلاء",
          text: "تبسيط العمليات لوكلاء العقارات باستخدام أدوات قوية لإدارة المهام، وتفاعلات العملاء، وتتبع الأداء.",
        },
        {
          id: 3,
          heading: "أدوات تحليل السوق",
          text: "الحصول على رؤى قيمة حول اتجاهات العقارات، والأسعار، وفرص الاستثمار من خلال حلول تحليلية قوية.",
        },
        {
          id: 4,
          heading: "منصات الحجز عبر الإنترنت",
          text: "تمكين حجز العقارات ومعالجة المعاملات بشكل آمن وفي الوقت الفعلي لتحسين تجربة المستخدم والثقة.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برمجيات عقارية تحويلية",
      discription:
        "نحن نقدم حلول برمجيات عقارية مبتكرة وقابلة للتطوير لتبسيط إدارة الممتلكات، وتعزيز تجارب العملاء، وتحسين العمليات التجارية.",
      accordionData: [
        {
          id: "collapseOne",
          title: "بوابات عقارية غنية بالميزات",
          content:
            "تطوير منصات متقدمة لقوائم العقارات مع قدرات بحث قوية، وخيارات حجز سلسة، وتجارب مستخدم بديهية للمشترين والمستأجرين.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "أنظمة إدارة الوكلاء",
          content:
            "تمكين وكلاء العقارات بأدوات لأتمتة المهام، وتتبع العملاء المتوقعين، وتحليلات الأداء، وتبسيط سير عملهم وتعزيز الكفاءة.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "حلول تحليل السوق",
          content:
            "تقديم رؤى قابلة للتنفيذ باستخدام أدوات لتحليل اتجاهات العقارات، والأسعار، وديناميكيات السوق، مما يتيح اتخاذ قرارات مستنيرة واستراتيجيات استثمار أفضل.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "منصات حجز آمنة عبر الإنترنت",
          content:
            "تسهيل حجوزات العقارات في الوقت الفعلي باستخدام أنظمة معاملات آمنة، مما يضمن تجربة موثوقة وخالية من المتاعب للمستخدمين.",
        },
      ],
    },
    industryFaqs: {
      heading: "إجابات على أسئلتك حول حلول العقارات",
      discription:
        "ابحث عن إجابات للأسئلة الشائعة حول خدمات تطوير برامج العقارات المبتكرة والآمنة لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "هل يمكنكم تطوير حلول مخصصة لبوابات العقارات؟",
          answer:
            "نعم، نحن متخصصون في بناء بوابات عقارية مخصصة مصممة لتلبية احتياجات عملك. من فلاتر البحث المتقدمة عن العقارات إلى الجولات الافتراضية، نقدم ميزات تعزز مشاركة المستخدم وتبسط العمليات.",
        },
        {
          id: "collapseTwo",
          question: "كيف تضمنون أمن بيانات العقارات والمعاملات؟",
          answer:
            "ننفيذ بروتوكولات أمان عالية المستوى، بما في ذلك التشفير من طرف إلى طرف، والمصادقة متعددة العوامل، والامتثال للائحة العامة لحماية البيانات (GDPR) و ISO 27001، مما يضمن بقاء بياناتك محمية.",
        },
        {
          id: "collapseThree",
          question:
            "هل يمكن لأنظمتكم التكامل مع الأدوات الحالية مثل أنظمة إدارة علاقات العملاء (CRMs)؟",
          answer:
            "نعم، يمكن لحلولنا التكامل بسلاسة مع أنظمة إدارة علاقات العملاء (CRMs)، وأنظمة تخطيط موارد المؤسسات (ERPs)، وغيرها من الأدوات لإنشاء منصة موحدة لعمليات العقارات، مما يحسن الكفاءة والتعاون.",
        },
        {
          id: "fourth",
          question:
            "هل تقدمون حلولًا للجولات الافتراضية والنمذجة ثلاثية الأبعاد؟",
          answer:
            "بالتأكيد! نحن نطور منصات جولات افتراضية تفاعلية وحلول نمذجة عقارات ثلاثية الأبعاد لتعزيز تجربة عرض العقارات للمشترين والمستأجرين.",
        },
        {
          id: "fifth",
          question: "كم يستغرق بناء بوابة عقارية؟",
          answer:
            "يعتمد الجدول الزمني على تعقيد المشروع ونطاقه. تستغرق بوابة العقارات القياسية عادة من 3 إلى 6 أشهر، بينما يمكن تطوير الميزات الأصغر أو المنتجات ذات الحد الأدنى من الميزات (MVPs) بسرعة أكبر.",
        },
        {
          id: "sixth",
          question: "ما هي أنواع أعمال العقارات التي تعملون معها؟",
          answer:
            "نحن نخدم وكالات العقارات، ومطوري العقارات، والوسطاء، وشركات إدارة الممتلكات، ونقدم حلولًا مخصصة لتلبية احتياجات العمل المتنوعة.",
        },
      ],
    },
  },

  {
    id: 5,
    title: "السيارات",
    slug: "automotive-logistics",
    metaTitle:
      "خدمات تطوير البرمجيات لصناعة السيارات | قيادة الابتكار والكفاءة",
    metaDes:
      "اطلق العنان لقوة الأتمتة باستخدام إنترنت الأشياء، وبرمجيات الروبوتات، وأدوات سير العمل. حسّن عملياتك الصناعية مع Bitsclan.",
    description:
      "يتطور عالم السيارات بسرعة، ويجب أن تتطور برامجك أيضًا! سواء كان ذلك تتبع المركبات، أو إدارة المخزون، أو التواصل مع العملاء، فإننا ننشئ حلولًا سهلة الاستخدام تبسط العمليات وتحسن التجارب.",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    icon: "/images/automotive-icon.png",
    image: "automotive.png",
    bannerHeading: "بناء برمجيات السيارات",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "automotive.avif",
    backgroundImage: "url(/images/industry-detial-banner-bg/automotive.avif)",
    discriptionSection: {
      heading: "إحداث ثورة في صناعة السيارات بالتكنولوجيا",
      discription:
        "تشهد صناعة السيارات تحولًا هائلاً مدفوعًا بالابتكار الرقمي. من المركبات المتصلة إلى إدارة الأساطيل الذكية، تمكّن حلولنا البرمجية المخصصة الشركات من البقاء في طليعة مشهد السيارات سريع التطور.",
      cardHeading: "خبرة في تكنولوجيا السيارات",
      cardDiscripiton:
        "نحن نقدم حلول برمجيات سيارات مبتكرة، بما في ذلك أنظمة المركبات المتصلة وتكامل أنظمة تحديد المواقع المتقدمة، لتعزيز الاتصال والأداء. تعمل أدوات إدارة الأساطيل والصيانة التنبؤية لدينا على تبسيط العمليات وتقليل وقت التوقف عن العمل. بالإضافة إلى ذلك، تمكّن أنظمة إدارة الوكلاء (DMS) لدينا وكلاء السيارات من إدارة المخزون والمبيعات والخدمة بكفاءة.",
    },
    statsSection: {
      backgroundImage: "automotive-counter-bg.avif",
      heading: "قد مستقبل",
      greenPart: "ابتكار السيارات",
      discription:
        "قيادة الابتكار في صناعة السيارات من خلال حلول برمجية متطورة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "السيارات",
      stats: [
        {
          count: "700+",
          text: "مشروع تم تسليمه في قطاع السيارات",
        },
        {
          count: "500+",
          text: "شركة سيارات مُمَكنة",
        },
        {
          count: "10,000+",
          text: "ميزة تم نشرها لتحسين المركبات والأساطيل",
        },
        {
          count: "97%",
          text: "معدل رضا العملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات السيارات",
      text: "أحدث ثورة في أعمالك في مجال السيارات من خلال حلول برمجية متطورة مصممة لتعزيز الكفاءة وتحسين إدارة الأساطيل وتقديم تجارب سلسة للمركبات المتصلة.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "أنظمة إدارة الأساطيل",
          text: "تحسين تتبع المركبات، وتخطيط المسارات، وجدولة الصيانة باستخدام حلول إدارة الأساطيل المتقدمة المصممة لتحقيق الكفاءة.",
          btnLink: "fleet-management-systems",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "أنظمة إدارة الوكلاء",
          text: "تبسيط عمليات المبيعات والخدمة والمخزون لوكلاء السيارات باستخدام حلول DMS قوية.",
          btnLink: "dealer-management-systems",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          heading: "منصات المركبات المتصلة",
          text: "تمكين مراقبة بيانات المركبات في الوقت الفعلي وأنظمة مساعدة السائق باستخدام منصات المركبات المتصلة المتطورة.",
          btnLink: "connected-vehicle-platforms",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير أمان البيانات والامتثال في مجال السيارات",
      discription:
        "يعد أمان البيانات أمرًا بالغ الأهمية في صناعة السيارات. نحن نلتزم بالمعايير العالمية مثل ISO/SAE 21434 لأمن الفضاء الإلكتروني واللائحة العامة لحماية البيانات (GDPR) لحماية البيانات. تضمن حلولنا التبادل الآمن للبيانات بين المركبات والأجهزة والأنظمة.",
      image: "automotive-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برمجيات السيارات لدينا",
      discription:
        "اكتشف حلول برمجيات السيارات المبتكرة والمصممة خصيصًا لتعزيز أداء المركبات، وتحسين إدارة الأساطيل، والارتقاء بعمليات الوكلاء.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "أنظمة المركبات المتصلة",
          text: "تمكين التواصل في الوقت الفعلي بين المركبات والبنية التحتية والأجهزة لتجارب قيادة أكثر ذكاءً وأمانًا.",
        },
        {
          id: 2,
          heading: "حلول تتبع المركبات (Telematics)",
          text: "مراقبة أداء المركبة وسلوك السائق وكفاءة استهلاك الوقود من خلال تتبع المركبات المتقدم لتحسين عمليات الأسطول.",
        },
        {
          id: 3,
          heading: "أدوات الصيانة التنبؤية",
          text: "تقليل وقت توقف المركبات عن العمل من خلال التشخيص المدعوم بالذكاء الاصطناعي وتنبيهات الصيانة، مما يضمن الإصلاحات في الوقت المناسب وموثوقية أكبر.",
        },
        {
          id: 4,
          heading: "منصات تأجير السيارات",
          text: "بناء منصات تأجير سيارات بديهية تتميز بأدوات حجز وتتبع وإدارة متقدمة لتجربة مستخدم سلسة.",
        },
        {
          id: 5,
          heading: "تكامل المركبات الكهربائية (EV)",
          text: "تطوير أنظمة متوافقة مع المركبات الكهربائية لمحطات الشحن وعمليات الأسطول والصيانة، مما يدعم التحول إلى النقل المستدام.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برمجيات السيارات المتقدمة",
      discription:
        "نحن متخصصون في تقديم حلول برمجيات السيارات المتطورة لتحسين إدارة الأساطيل، وتعزيز أداء المركبات، ودعم نمو شركات السيارات.",
      accordionData: [
        {
          id: "collapseOne",
          title: "أنظمة المركبات المتصلة",
          content:
            "تمكين الاتصال في الوقت الفعلي بين المركبات والبنية التحتية والأجهزة، مما يحسن تجارب القيادة والسلامة والكفاءة التشغيلية.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "أنظمة إدارة الأساطيل",
          content:
            "تحسين عمليات الأساطيل من خلال أدوات تتبع المركبات القوية وتخطيط المسارات وجدولة الصيانة، مما يضمن إدارة سلسة وفعالة من حيث التكلفة.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "أدوات الصيانة التنبؤية",
          content:
            "تقليل وقت التوقف عن العمل وخفض تكاليف الصيانة من خلال التشخيص المدعوم بالذكاء الاصطناعي والتنبيهات في الوقت الفعلي والتحليلات التنبؤية للصيانة الوقائية للمركبات.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "حلول تتبع المركبات (Telematics)",
          content:
            "مراقبة أداء المركبة وسلوك السائق وكفاءة استهلاك الوقود باستخدام أدوات تتبع المركبات المتقدمة، مما يمكّن مديري الأساطيل من تحسين العمليات وتحسين الأداء.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "أسئلة متكررة حول تطوير برمجيات السيارات",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برمجيات السيارات لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "هل يمكنكم تطوير برمجيات للمركبات المتصلة؟",
          answer:
            "نعم، نحن متخصصون في إنشاء حلول المركبات المتصلة التي تتضمن مراقبة البيانات في الوقت الفعلي، والتواصل بين المركبات والبنية التحتية، وأنظمة مساعدة السائق المتقدمة (ADAS).",
        },
        {
          id: "collapseTwo",
          question: "كيف تضمنون أمن بيانات تتبع المركبات (telematics)؟",
          answer:
            "ننفيذ تدابير قوية لأمن الفضاء الإلكتروني مثل التشفير من طرف إلى طرف، وبروتوكولات الاتصال الآمنة، والامتثال لمعايير الصناعة مثل ISO/SAE 21434، مما يضمن تبادل البيانات بشكل آمن.",
        },
        {
          id: "collapseThree",
          question: "ما هو الجدول الزمني النموذجي لبناء برمجيات السيارات؟",
          answer:
            "يعتمد الجدول الزمني على نطاق المشروع. يمكن أن يستغرق نظام إدارة الأسطول أو حلول تتبع المركبات النموذجية من 3 إلى 6 أشهر، بينما قد تتطلب الحلول الأكثر تعقيدًا مثل منصات المركبات المتصلة من 6 إلى 12 شهرًا.",
        },
        {
          id: "fourth",
          question: "هل يمكنكم دمج إنترنت الأشياء في حلول السيارات؟",
          answer:
            "بالتأكيد! نحن نطور أنظمة سيارات تدعم إنترنت الأشياء للتتبع في الوقت الفعلي، والصيانة التنبؤية، وتحليل أداء المركبات.",
        },
        {
          id: "fifth",
          question: "هل تعملون مع منصات المركبات الكهربائية (EV)؟",
          answer:
            "نعم، نحن نقدم حلولًا مصممة خصيصًا للمركبات الكهربائية، بما في ذلك تكامل محطات الشحن، وأنظمة مراقبة البطارية، وإدارة الأسطول للمركبات الكهربائية.",
        },
        {
          id: "sixth",
          question: "ما هي أنواع شركات السيارات التي تخدمونها؟",
          answer:
            "نحن نعمل مع مصنعي السيارات، ومشغلي الأساطيل، ووكالات تأجير السيارات، والوكلاء، وشركات المركبات الكهربائية، ونقدم حلول برمجية مخصصة لتلبية احتياجاتهم.",
        },
      ],
    },
  },

  {
    id: 6,
    title: "التعليم",
    slug: "education",
    metaTitle: "خدمات تطوير البرمجيات التعليمية | حلول ذكية للتعلم",
    metaDes:
      "عزز تجربة التعلم مع خدماتنا لتطوير برمجيات تعليمية مخصصة. نقدم حلولاً ذكية وقابلة للتطوير للتعليم الإلكتروني والفصول الدراسية الافتراضية والمنصات التعليمية.",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "يجب أن يكون التعليم جذابًا ومتاحًا، وتطبيقات الويب الخاصة بنا تجعل ذلك حقيقة. من منصات التعلم الإلكتروني إلى أدوات إدارة الفصول الدراسية، نصمم حلولًا تلبي احتياجات الطلاب والمعلمين والمؤسسات، وتقرب الجميع من النجاح.",
    icon: "/images/education-icon.png",
    image: "education.png",
    bannerHeading: "بناء برمجيات التعليم",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "edtech-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/education.avif)",
    discriptionSection: {
      heading: "إحداث ثورة في التعليم بالحلول الرقمية",
      discription:
        "يتطور قطاع التعليم بسرعة، حيث تعيد الأدوات الرقمية تعريف كيفية نقل المعرفة واستيعابها. من منصات التعلم الإلكتروني إلى الفصول الدراسية الافتراضية، تمكّن حلولنا المبتكرة المؤسسات التعليمية وشركات التكنولوجيا التعليمية من تقديم تجارب تعليمية مخصصة وجذابة ومؤثرة.",
      cardHeading: "خبرة في التكنولوجيا التعليمية",
      cardDiscripiton:
        "نحن نطور أنظمة إدارة تعلم (LMS) قوية لتبسيط إدارة الدورات التدريبية وتتبع تقدم الطلاب. تعمل منصات التعلم التكيفي المدعومة بالذكاء الاصطناعي على تخصيص المحتوى التعليمي لكل طالب، مما يعزز تجربة التعلم لديهم. بالإضافة إلى ذلك، نقدم أدوات للفصول الدراسية الافتراضية، وتأليف الدورات التدريبية، وأنظمة معلومات الطلاب (SIS)، وكلها مصممة لتحسين التعاون وتقديم المحتوى وإدارة البيانات في البيئات التعليمية.",
    },
    statsSection: {
      backgroundImage: "edtech-counter-bd.avif",
      heading: "قد مستقبل",
      greenPart: "تكنولوجيا التعليم",
      discription:
        "دفع الابتكار في التعليم من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "التعليم",
      stats: [
        {
          count: "800+",
          text: "مشروع تعليمي تم تسليمه",
        },
        {
          count: "1,000+",
          text: "مدرسة وجامعة تم تحويلها رقميًا",
        },
        {
          count: "10M+",
          text: "طالب استفادوا من منصاتنا",
        },
        {
          count: "96%",
          text: "معدل رضا العملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات التعليم",
      text: "أحدث ثورة في التعليم من خلال حلول برمجية مبتكرة مصممة لتعزيز تجارب التعلم، وتبسيط الإدارة، وتمكين المؤسسات بأحدث التقنيات.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "أنظمة إدارة التعلم (LMS)",
          text: "تصميم منصات سهلة الاستخدام لإدارة الدورات التدريبية، وتتبع التقدم، وتقييم الأداء باستخدام حلول LMS متقدمة مصممة خصيصًا للمؤسسات التعليمية.",
          btnLink: "learning-management-systems",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "الفصول الدراسية الافتراضية",
          text: "إنشاء بيئات تفاعلية للتعليم والتعاون عبر الإنترنت في الوقت الفعلي، مما يعزز تجربة التعلم للطلاب والمعلمين.",
          btnLink: "virtual-classrooms",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          heading: "أدوات التعلم المدعومة بالذكاء الاصطناعي",
          text: "تمكين تجارب التعلم المخصصة من خلال توصيات مدفوعة بالذكاء الاصطناعي، وتحليل التقدم، وحلول التعلم التكيفي لدعم احتياجات الطلاب المتنوعة.",
          btnLink: "ai-powered-learning-tools",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج التعليم والامتثال الأمني",
      discription:
        "نحن نلتزم بمعايير الصناعة ومتطلبات الامتثال مثل قانون حقوق الأسرة التعليمية والخصوصية (FERPA) واللائحة العامة لحماية البيانات (GDPR) لضمان خصوصية البيانات وأمنها للطلاب والمعلمين والمؤسسات. تضمن حلولنا بيئة تعليمية آمنة وموثوقة.",
      image: "edtech-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برمجيات التعليم لدينا",
      discription:
        "اكتشف حلول برمجيات التعليم المبتكرة والمصممة خصيصًا لتبسيط إدارة الدورات التدريبية، وتعزيز تجارب التعلم، وتمكين المؤسسات التعليمية من تحقيق النجاح الأكاديمي.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "أنظمة إدارة التعلم (LMS)",
          text: "تبسيط تقديم الدورات التدريبية، والتقييمات، وإعداد التقارير باستخدام حلول LMS قوية مصممة خصيصًا للمؤسسات التعليمية.",
        },
        {
          id: 2,
          heading: "أنظمة معلومات الطلاب (SIS)",
          text: "إدارة بيانات الطلاب، والحضور، والسجلات الأكاديمية بكفاءة باستخدام حل SIS شامل لتبسيط عمليات المدرسة.",
        },
        {
          id: 3,
          heading: "منصات التعلم الإلكتروني",
          text: "بناء منصات غامرة وقابلة للتطوير للتعلم عبر الإنترنت، مما يوفر تجربة تعليمية مرنة وجذابة للطلاب في جميع أنحاء العالم.",
        },
        {
          id: 4,
          heading: "برنامج إدارة الامتحانات",
          text: "أتمتة جدولة الامتحانات، وتصحيحها، وتتبع النتائج، مما يعزز الكفاءة والدقة في التقييمات الأكاديمية.",
        },
        {
          id: 5,
          heading: "حلول التدريب المؤسسي",
          text: "إنشاء حلول مخصصة للتطوير المهني، ورفع مستوى المهارات، والتدريب المؤسسي لتعزيز أداء الموظفين ونموهم.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برمجيات تعليمية مبتكرة",
      discription:
        "نحن نقدم حلول برمجيات متقدمة مصممة خصيصًا للمؤسسات التعليمية، مما يعزز مشاركة الطلاب، ويبسط الإدارة، ويعزز نتائج التعلم الأفضل.",
      accordionData: [
        {
          id: "collapseOne",
          title: "أنظمة إدارة الدورات التدريبية",
          content:
            "إنشاء منصات بديهية تبسط تقديم الدورات التدريبية، وتتبع تقدم الطلاب، وتقدم تقييمات مفصلة لتحسين فعالية التدريس ونتائج التعلم.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "حلول إدارة بيانات الطلاب",
          content:
            "تنظيم وإدارة سجلات الطلاب والحضور والأداء الأكاديمي بكفاءة من خلال أنظمة آلية تقلل عبء العمل الإداري وتضمن دقة البيانات.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "حلول التعلم عبر الإنترنت",
          content:
            "تصميم منصات تعلم عبر الإنترنت تفاعلية وجذابة تدعم التعليم عن بُعد، وتعزز الفصول الدراسية الافتراضية، وتوفر تجارب تعلم غنية للطلاب.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "أنظمة التقييم والاختبار",
          content:
            "تبسيط عملية التقييم بأكملها من خلال جدولة الامتحانات الآلية، والتصحيح، وتحليل النتائج، مما يضمن تقييمًا دقيقًا وفي الوقت المناسب لأداء الطلاب.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج التعليم",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج التعليم لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "هل يمكنكم بناء منصات LMS مخصصة؟",
          answer:
            "نعم، نحن متخصصون في إنشاء أنظمة إدارة تعلم (LMS) مصممة خصيصًا مع ميزات مثل إدارة الدورات التدريبية، والتحليلات، والتكامل مع أدوات الجهات الخارجية.",
        },
        {
          id: "collapseTwo",
          question: "هل تقدمون حلولًا للفصول الدراسية الافتراضية؟",
          answer:
            "بالتأكيد! نحن نطور أدوات الفصول الدراسية الافتراضية مع ميزات الفيديو والدردشة والتعاون في الوقت الفعلي لتعزيز تجارب التدريس عبر الإنترنت.",
        },
        {
          id: "collapseThree",
          question: "ما هو الجدول الزمني لتطوير منصة للتعلم الإلكتروني؟",
          answer:
            "يختلف الجدول الزمني حسب نطاق المشروع. عادةً، تستغرق منصة التعلم الإلكتروني القياسية من 4 إلى 6 أشهر، بينما قد تتطلب الميزات الأكثر تقدمًا من 6 إلى 9 أشهر.",
        },
        {
          id: "fourth",
          question: "كيف تضمنون خصوصية بيانات الطلاب؟",
          answer:
            "نحن نتبع المعايير العالمية مثل قانون حقوق الأسرة التعليمية والخصوصية (FERPA) واللائحة العامة لحماية البيانات (GDPR)، ونطبق تشفيرًا قويًا، ومصادقة آمنة، وضوابط وصول لحماية البيانات الحساسة.",
        },
        {
          id: "fifth",
          question: "هل تدعمون تطبيقات التعلم عبر الهاتف المحمول؟",
          answer:
            "نعم، نقوم بتصميم وتطوير حلول التعلم الإلكتروني المتوافقة مع الأجهزة المحمولة لضمان الوصول السلس إلى موارد التعلم في أي وقت وفي أي مكان.",
        },
        {
          id: "sixth",
          question: "هل يمكنكم دمج الأدوات التعليمية الموجودة مع حلولكم؟",
          answer:
            "نعم، تدعم حلولنا التكامل مع أدوات مثل Google Classroom و Microsoft Teams وتطبيقات الجهات الخارجية الأخرى لضمان تجربة تعليمية متكاملة.",
        },
      ],
    },
  },

  {
    id: 7,
    title: "التأمين",
    metaTitle: "خدمات تطوير البرمجيات لقطاع التأمين | حلول رقمية موثوقة",
    metaDes:
      "طوّر أعمالك التأمينية مع خدماتنا لتطوير البرمجيات المخصصة. نبني حلولاً رقمية موثوقة لإدارة الوثائق، ومعالجة المطالبات، والتفاعل مع العملاء.",
    slug: "insurance",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "نجعل عمليات التأمين سلسة وخالية من المتاعب. تطبيقات الويب الخاصة بنا تبسط المطالبات، وتدير السياسات، وتحسن التواصل مع العملاء. تم تصميم هذه الحلول الآمنة والفعالة للتكيف مع الاحتياجات المتغيرة باستمرار لقطاع التأمين.",
    icon: "/images/Insurance.png",
    image: "insurance.png",
    bannerHeading: "بناء برمجيات التأمين",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "insurance-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/Insurance.avif)",
    discriptionSection: {
      heading: "تحويل التأمين من خلال التكنولوجيا",
      discription:
        "تشهد صناعة التأمين ثورة رقمية، حيث تمكّن التكنولوجيا تجارب العملاء المخصصة، ومعالجة المطالبات بشكل أسرع، وإدارة السياسات بكفاءة. تمكّن حلولنا المتطورة مزودي التأمين من تبسيط العمليات، وتعزيز اتخاذ القرار، وتقديم قيمة لعملائهم.",
      cardHeading: "خبرة في تكنولوجيا التأمين",
      cardDiscripiton:
        "بسّط عمليات التأمين الخاصة بك من خلال أنظمة إدارة المطالبات، وأتمتة الاكتتاب، والتحليلات التنبؤية المدعومة بالذكاء الاصطناعي. عزز علاقات العملاء من خلال حلول إدارة علاقات العملاء (CRM) المخصصة وتبسيط إدارة السياسات من خلال إدارة السياسات السلسة.",
    },
    statsSection: {
      backgroundImage: "insurance-counter-bg.avif",
      heading: "قُد مستقبل",
      greenPart: "التأمين الرقمي",
      discription:
        "قيادة الابتكار في التأمين الرقمي من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "التأمين",
      stats: [
        {
          count: "500+",
          text: "حلول برمجية للتأمين تم تسليمها",
        },
        {
          count: "200+",
          text: "شركة تأمين تم تمكينها رقميًا",
        },
        {
          count: "10M+",
          text: "وثيقة تم إدارتها من خلال منصاتنا",
        },
        {
          count: "95%",
          text: "معدل الاحتفاظ بالعملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات التأمين",
      text: "حوّل أعمالك في مجال التأمين من خلال حلول برمجية مبتكرة مصممة لتبسيط إدارة المطالبات، وأتمتة الاكتتاب، وتعزيز علاقات العملاء باستخدام أحدث التقنيات.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "أنظمة إدارة المطالبات",
          text: "تبسيط وأتمتة دورة حياة المطالبات لسرعة الحل والشفافية، مما يحسن الكفاءة ورضا العملاء.",
          btnLink: "claims-management-systems",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "حلول الاكتتاب",
          text: "استفد من الذكاء الاصطناعي والتعلم الآلي لتقييم المخاطر والاكتتاب بدقة، مما يعزز اتخاذ القرار والكفاءة التشغيلية.",
          btnLink: "underwriting-solutions",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          heading: "برنامج إدارة السياسات",
          text: "تبسيط إدارة وثائق التأمين من الإصدار إلى التجديد، مما يضمن عمليات سلسة ورضا العملاء.",
          btnLink: "policy-administration-software",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج التأمين والامتثال",
      discription:
        "نحن نلتزم بالمعايير التنظيمية مثل اللائحة العامة لحماية البيانات (GDPR)، وقانون قابلية نقل التأمين الصحي والمساءلة (HIPAA) (للتأمين الصحي)، ومعيار أمان بيانات صناعة بطاقات الدفع (PCI DSS) (لأمان الدفع) لضمان الامتثال والأمان وخصوصية البيانات في جميع حلولنا. تم بناء منصاتنا للتعامل مع المعلومات الحساسة بأمان وكفاءة.",
      image: "insurance-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برمجيات التأمين لدينا",
      discription:
        "اكتشف حلول برمجيات التأمين المبتكرة والمصممة خصيصًا لتبسيط إدارة المطالبات، وتعزيز دقة الاكتتاب، وتحسين إدارة السياسات لتحسين أداء الأعمال.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "برنامج إدارة المطالبات",
          text: "تمكين معالجة المطالبات السريعة والخالية من المتاعب، وتقليل وقت الاستجابة، وتعزيز رضا العملاء.",
        },
        {
          id: 2,
          heading: "إدارة علاقات العملاء (CRM)",
          text: "تحسين تفاعلات العملاء، وتعزيز الاحتفاظ بهم، ودفع الولاء من خلال حل شامل لإدارة علاقات العملاء لشركات التأمين.",
        },
        {
          id: 3,
          heading: "منصات إدارة السياسات",
          text: "إدارة السياسات والتجديدات والتعديلات بكفاءة، مما يضمن عمليات مبسطة وخدمة عملاء محسنة.",
        },
        {
          id: 4,
          heading: "أدوات تقييم المخاطر",
          text: "الاستفادة من الرؤى المدفوعة بالذكاء الاصطناعي لإجراء تقييمات دقيقة للمخاطر وقرارات اكتتاب أفضل في عملية التأمين.",
        },
        {
          id: 5,
          heading: "منصات InsurTech",
          text: "تطوير حلول رقمية من الجيل التالي لخدمات التأمين المبتكرة، وتحويل الصناعة باستخدام التكنولوجيا المتقدمة.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برمجيات تأمين ذكية وبسيطة",
      discription:
        "نحن ننشئ برامج تأمين سهلة الاستخدام تساعد في إدارة السياسات، وتسريع المطالبات، وتحسين خدمة العملاء، وتجعل المهام اليومية خالية من المتاعب لشركات التأمين والوكلاء.",
      accordionData: [
        {
          id: "collapseOne",
          title: "أنظمة إدارة السياسات",
          content:
            "تعامل بسهولة مع جميع وثائق التأمين الخاصة بك في مكان واحد، من إنشاء وثائق جديدة إلى تحديث الوثائق القديمة. لا مزيد من الأعمال الورقية الفوضوية، فقط عمليات سلسة!",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "حلول معالجة المطالبات",
          content:
            "عندما تسوء الأمور، المطالبات السريعة مهمة. يساعد هذا النظام على تسريع الموافقات، وتتبع التقدم، والحصول على المدفوعات دون عناء.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "إدارة علاقات العملاء (CRM) للتأمين",
          content:
            "إبقاء العملاء سعداء هو المفتاح! إدارة جهات الاتصال، وتتبع المحادثات، وإرسال التذكيرات حتى لا يشعر أحد بالنسيان.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "أدوات تقييم المخاطر والاكتتاب",
          content:
            "اعرف المخاطر قبل أن توافق! تساعد هذه الأدوات في تحليل تفاصيل العميل وتحديد أفضل تغطية بأقل تخمين.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج التأمين",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج التأمين لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "هل يمكنكم تطوير منصات تأمين مخصصة؟",
          answer:
            "نعم، نحن متخصصون في إنشاء حلول مصممة خصيصًا لإدارة المطالبات، وإدارة السياسات، وإدارة علاقات العملاء لتلبية احتياجات عملك الفريدة.",
        },
        {
          id: "collapseTwo",
          question: "هل تقدمون حلول الذكاء الاصطناعي لمعالجة المطالبات؟",
          answer:
            "بالتأكيد! ندمج الذكاء الاصطناعي في أنظمة إدارة المطالبات لأتمتة الكشف عن الاحتيال، وتسريع الموافقات، وضمان الدقة في المعالجة.",
        },
        {
          id: "collapseThree",
          question: "كم يستغرق بناء برنامج تأمين؟",
          answer:
            "يعتمد الجدول الزمني على تعقيد المشروع. تستغرق الحلول القياسية من 3 إلى 6 أشهر، بينما قد تستغرق المنصات الأكثر تقدمًا أو المخصصة من 6 إلى 12 شهرًا.",
        },
        {
          id: "fourth",
          question: "كيف تضمنون الامتثال للوائح الصناعة؟",
          answer:
            "نحن نتبع المعايير العالمية مثل اللائحة العامة لحماية البيانات (GDPR)، وقانون قابلية نقل التأمين الصحي والمساءلة (HIPAA)، ومعيار أمان بيانات صناعة بطاقات الدفع (PCI DSS) لضمان الامتثال وأمن البيانات عبر جميع حلولنا.",
        },
        {
          id: "fifth",
          question:
            "هل يمكن لمنصاتكم التكامل مع أدوات التأمين الخاصة بجهات خارجية؟",
          answer:
            "نعم، نضمن التكامل السلس مع أدوات الجهات الخارجية مثل محركات الاكتتاب، وبوابات الدفع، ومنصات التحليلات لتقديم وظائف شاملة.",
        },
        {
          id: "sixth",
          question: "هل تقدمون حلول تأمين متوافقة مع الأجهزة المحمولة؟",
          answer:
            "نعم، حلولنا سريعة الاستجابة ومتوافقة تمامًا مع الأجهزة المحمولة، مما يتيح للعملاء الوصول إلى الخدمات مثل إدارة السياسات وتقديم المطالبات أثناء التنقل.",
        },
      ],
    },
  },

  {
    id: 8,
    metaTitle: "خدمات تطوير البرمجيات للوجستيات | تحسين عمليات سلسلة التوريد",
    metaDes:
      "حسّن سلسلة التوريد لديك مع خدماتنا لتطوير برامج الخدمات اللوجستية. نبتكر حلولاً ذكية وقابلة للتطوير لإدارة الأساطيل، وتتبع الطلبات، وأتمتة المستودعات.",
    title: "اللوجستيات",
    slug: "logistics",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "الكفاءة هي العمود الفقري للوجستيات، ونحن هنا لتقديمها. تبسط تطبيقات الويب الخاصة بنا سلاسل التوريد من خلال التتبع في الوقت الفعلي، وإدارة الأسطول، والتحكم في المخزون. تظل الشركات منظمة ويظل العملاء على اطلاع، في كل خطوة على الطريق.",
    icon: "/images/logistics.avif",
    image: "logistics.avif",
    bannerHeading: "بناء برمجيات اللوجستيات",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "logistics-transportation-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/logistics.avif)",
    discriptionSection: {
      heading: "إحداث ثورة في اللوجستيات بالتكنولوجيا",
      discription:
        "تتطور صناعة اللوجستيات بسرعة، مدفوعة بالحاجة إلى الكفاءة والشفافية وقابلية التوسع. تمكّن حلولنا البرمجية اللوجستية المبتكرة الشركات من تحسين سلاسل التوريد، وإدارة الأساطيل بفعالية، وتقديم تجارب عملاء فائقة. من خلال التتبع في الوقت الفعلي والتحليلات المتقدمة، نساعدك على تحقيق عمليات سلسة وكفاءة في التكلفة.",
      cardHeading: "خبرة في تكنولوجيا اللوجستيات",
      cardDiscripiton:
        "حسّن إدارة الأسطول، وبسّط سلاسل التوريد، وعزّز كفاءة المستودعات باستخدام حلول متطورة. يعزز التتبع في الوقت الفعلي، والتخطيط الذكي للمسارات، والرؤية السلسة العمليات ويسرّع عمليات التسليم. زد الإنتاجية إلى أقصى حد وحسّن تلبية الطلبات باستخدام أدوات قوية مصممة للحفاظ على سير العمل بسلاسة.",
    },
    statsSection: {
      backgroundImage: "logistic-counter-bg.avif",
      heading: "قد مستقبل",
      greenPart: "اللوجستيات الذكية",
      discription:
        "قيادة الابتكار في اللوجستيات الذكية من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "اللوجستيات",
      stats: [
        {
          count: "700+",
          text: "حلول لوجستية تم تسليمها",
        },
        {
          count: "300+",
          text: "شركة تم خدمتها عالميًا",
        },
        {
          count: "99%",
          text: "تحسين التسليم في الوقت المحدد",
        },
        {
          count: "95%",
          text: "معدل رضا العملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات اللوجستيات",
      text: "أحدث ثورة في عملياتك اللوجستية من خلال حلول برمجية متطورة مصممة لتحسين إدارة الأسطول، وتبسيط سلاسل التوريد، وتعزيز التتبع في الوقت الفعلي للعمليات السلسة.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "أنظمة إدارة الأساطيل",
          text: "تمكين التتبع والمراقبة والصيانة الفعالة لأسطولك، مما يضمن عمليات سلسة ويقلل وقت التوقف عن العمل.",
          btnLink: "fleet-management-systems",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "تحسين سلسلة التوريد",
          text: "أتمتة وتبسيط عمليات سلسلة التوريد لزيادة الكفاءة، وخفض التكاليف، وتعزيز أداء التسليم.",
          btnLink: "supply-chain-optimization",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          heading: "حلول إدارة المستودعات",
          text: "تبسيط تتبع المخزون، والالتقاط، وعمليات الشحن، مما يحسن الدقة ويقلل النفقات التشغيلية.",
          btnLink: "warehouse-management-solutions",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج اللوجستيات والامتثال",
      discription:
        "تتوافق حلولنا مع المعايير الدولية مثل ISO 9001 لإدارة الجودة واللائحة العامة لحماية البيانات (GDPR) لخصوصية البيانات. نضمن الالتزام باللوائح الخاصة بالصناعة، مما يسمح لشركات اللوجستيات بالعمل بأمان وكفاءة في سوق عالمي.",
      image: "logistic-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برمجيات اللوجستيات لدينا",
      discription:
        "اكتشف حلول برمجيات لوجستية مبتكرة ومصممة خصيصًا لتوفير التتبع في الوقت الفعلي، وتحسين تخطيط المسارات، وتبسيط إدارة المستودعات، وتحسين كفاءة سلسلة التوريد لتحقيق نتائج أعمال أفضل.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "منصات التتبع في الوقت الفعلي",
          text: "توفير الشفافية والتحديثات حول الشحنات العابرة، مما يضمن تتبعًا دقيقًا وفي الوقت المناسب لتحسين رضا العملاء.",
        },
        {
          id: 2,
          heading: "أدوات تحسين المسار",
          text: "تقليل تكاليف الوقود وتحسين أوقات التسليم من خلال تخطيط المسار المدعوم بالذكاء الاصطناعي، مما يزيد من الكفاءة في عمليات النقل.",
        },
        {
          id: 3,
          heading: "أنظمة إدارة المستودعات",
          text: "تحسين التخزين، وإدارة المخزون، وعمليات تلبية الطلبات، مما يضمن عمليات سلسة وتسليمات في الوقت المناسب.",
        },
        {
          id: 4,
          heading: "حلول إدارة الشحن",
          text: "تبسيط توجيه الشحن، والجدولة، وتقدير التكلفة، وتحسين سير عمل اللوجستيات وتقليل التكاليف التشغيلية.",
        },
        {
          id: 5,
          heading: "تحليلات سلسلة التوريد",
          text: "الاستفادة من البيانات لتحديد أوجه القصور، وتبسيط العمليات، وتحسين اتخاذ القرار لتعزيز أداء سلسلة التوريد.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برمجيات لوجستية مبتكرة",
      discription:
        "نحن متخصصون في تقديم حلول برمجيات لوجستية متطورة تعمل على تحسين إدارة الأسطول، وتعزيز التتبع في الوقت الفعلي، وتحسين تخطيط المسارات، وتبسيط عمليات سلسلة التوريد لتحقيق كفاءة وأداء أفضل.",
      accordionData: [
        {
          id: "collapseOne",
          title: "أنظمة إدارة الأساطيل",
          content:
            "تمكين التتبع والمراقبة والصيانة الفعالة لأسطولك باستخدام بيانات في الوقت الفعلي، مما يضمن خفض تكاليف التشغيل وتحسين أداء الأسطول.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "تحسين سلسلة التوريد",
          content:
            "أتمتة وتبسيط عمليات سلسلة التوريد لتعزيز الكفاءة، وتقليل الاختناقات، وتحسين اتخاذ القرار من خلال التحليلات المتقدمة والرؤى المدفوعة بالذكاء الاصطناعي.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "التتبع والرؤية في الوقت الفعلي",
          content:
            "توفير رؤية شاملة للشحنات العابرة، وتقديم تحديثات في الوقت الفعلي للعملاء وتعزيز الشفافية طوال عملية التسليم.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "تخطيط المسار وتحسينه",
          content:
            "الاستفادة من خوارزميات الذكاء الاصطناعي والتعلم الآلي لتحسين مسارات التسليم، وتقليل تكاليف الوقود، وتحسين أوقات التسليم، وضمان استراتيجية النقل الأكثر كفاءة.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج اللوجستيات",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج اللوجستيات لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question:
            "هل يمكنكم دمج التتبع في الوقت الفعلي في منصة اللوجستيات الخاصة بنا؟",
          answer:
            "نعم، نحن متخصصون في دمج أنظمة التتبع في الوقت الفعلي القائمة على نظام تحديد المواقع العالمي (GPS) في منصة اللوجستيات الخاصة بك لتعزيز رؤية الشحنات والشفافية.",
        },
        {
          id: "collapseTwo",
          question: "كيف تعمل حلولكم على تحسين سلاسل التوريد؟",
          answer:
            "تستفيد حلولنا من التحليلات المتقدمة والذكاء الاصطناعي والتعلم الآلي لتحديد أوجه القصور وتقليل التكاليف وتحسين تدفق العمليات عبر سلسلة التوريد.",
        },
        {
          id: "collapseThree",
          question: "هل تقدمون أنظمة مخصصة لإدارة الأساطيل؟",
          answer:
            "بالتأكيد! نصمم أنظمة إدارة الأساطيل المصممة خصيصًا لاحتياجاتك التشغيلية، بما في ذلك التتبع وجدولة الصيانة وتحليلات الأداء.",
        },
        {
          id: "fourth",
          question: "ما هي الصناعات التي يمكن أن تستفيد من حلولكم اللوجستية؟",
          answer:
            "تخدم حلولنا صناعات مثل التجزئة والتجارة الإلكترونية والتصنيع والتوزيع، مما يضمن عمليات لوجستية فعالة لجميع القطاعات.",
        },
        {
          id: "fifth",
          question: "كم يستغرق تطوير برامج اللوجستيات؟",
          answer:
            "اعتمادًا على التعقيد، تتراوح الجداول الزمنية للتطوير من 3-6 أشهر للحلول القياسية إلى 6-12 شهرًا للأنظمة المخصصة.",
        },
        {
          id: "sixth",
          question: "هل تدعم منصاتكم ميزات متعددة اللغات ومتعددة العملات؟",
          answer:
            "نعم، تم بناء منصاتنا لدعم واجهات متعددة اللغات ومعاملات متعددة العملات للعمليات العالمية.",
        },
      ],
    },
  },

  {
    id: 9,
    title: "الترفيه",
    slug: "entertainment",
    metaTitle:
      "خدمات تطوير البرمجيات لقطاع الترفيه | جذب الجماهير بحلول مبتكرة",
    metaDes:
      "قدّم تجارب آسرة مع خدماتنا لتطوير برامج الترفيه. نطوّر حلولاً مبتكرة للبثّ وإدارة الوسائط ومنصات المحتوى التفاعلي.",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "تشمل حلول الترفيه لدينا أنظمة إدارة المحتوى، ومنصات تحليل الجمهور، وأدوات حماية الملكية الفكرية، مما يحسن توزيع المحتوى والمشاركة.",
    icon: "/images/entertainment.avif",
    image: "entertainmentMain.png",
    bannerHeading: "بناء برمجيات الترفيه",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "travel-entertainment-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/entertainment.avif)",
    discriptionSection: {
      heading: "تشكيل مستقبل",
      discription:
        "صناعة الترفيه، تزدهر صناعة الترفيه على الإبداع والابتكار، وتتطلب تكنولوجيا قوية لتقديم تجارب غامرة. تمكّن حلول برامج الترفيه لدينا شركات الإعلام، ومنصات البث، ومنظمي الأحداث، ومنشئي المحتوى من جذب الجماهير، وتحقيق الدخل من المحتوى بفعالية، والبقاء في المقدمة في سوق تنافسي.",
      cardHeading: "خبرة في تكنولوجيا الترفيه",
      cardDiscripiton:
        "ارتقِ بإدارة الترفيه والأحداث الخاصة بك من خلال حلولنا المتطورة. نقدم منصات بث فيديو سلسة، وأنظمة إدارة أحداث فعالة، وأدوات قوية لإدارة المحتوى. يعزز تكامل الواقع المعزز/الواقع الافتراضي مشاركة الجمهور، بينما يوفر نظام التذاكر المتقدم وتحليلات الجمهور رؤى قيمة لتحسين أحداثك.",
    },
    statsSection: {
      backgroundImage: "entertainment-counter-bg.avif",
      heading: "قُد مستقبل",
      greenPart: "الترفيه الرقمي",
      discription:
        "قيادة الابتكار في الترفيه الذكي من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "الترفيه",
      stats: [
        {
          count: "800+",
          text: "مشروع ترفيهي تم تسليمه",
        },
        {
          count: "500+",
          text: "شركة تم خدمتها عالميًا",
        },
        {
          count: "98%",
          text: "تحسين معدل المشاركة",
        },
        {
          count: "96%",
          text: "معدل رضا العملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات الترفيه",
      text: "حوّل أعمالك في مجال الترفيه من خلال حلول برمجية مبتكرة مصممة لتعزيز بث الفيديو، وتبسيط إدارة الأحداث، وتوفير تجارب واقع معزز/واقع افتراضي غامرة لجذب الجماهير.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "منصات بث الفيديو",
          text: "بناء منصات قابلة للتوسع لبث الفيديو المباشر أو عند الطلب بسلاسة، مما يضمن تجارب مستخدم عالية الجودة.",
          btnLink: "video-streaming-platforms",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "حلول إدارة الأحداث",
          text: "إدارة الحفلات الموسيقية والمهرجانات والمؤتمرات من خلال تذاكر فعالة وأدوات للجمهور وتحليلات في الوقت الفعلي.",
          btnLink: "event-management-solutions",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/arvr-icon.png",
          heading: "تجارب الواقع المعزز/الواقع الافتراضي (AR/VR)",
          text: "دمج الواقع المعزز والواقع الافتراضي لتجارب ترفيهية غامرة تجذب الجماهير وتأسرها.",
          btnLink: "arvr-experiences",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج الترفيه والامتثال",
      discription:
        "تتوافق حلولنا مع معايير الوسائط العالمية مثل DASH للبث التكيفي وتلتزم بلوائح حماية حقوق الطبع والنشر مثل قانون الألفية للملكية الرقمية (DMCA). نعطي الأولوية لمعالجة البيانات الآمنة لحماية خصوصية المستخدم وسلامة المحتوى.",
      image: "entertainment-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برامج الترفيه لدينا",
      discription:
        "اكتشف حلول برامج ترفيهية مبتكرة ومصممة خصيصًا لتقديم بث فيديو سلس، وتحسين إدارة الأحداث، ودمج تجارب الواقع المعزز/الواقع الافتراضي الغامرة لتعزيز مشاركة الجمهور ونجاح الأعمال.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "منصات البث",
          text: "إنشاء تجارب شخصية وتفاعلية لجمهورك، وتقديم محتوى مباشر وعند الطلب بسلاسة.",
        },
        {
          id: 2,
          heading: "أنظمة حجز تذاكر الأحداث",
          text: "تبسيط حجز التذاكر عبر الإنترنت، وتخصيص المقاعد، والمدفوعات لتبسيط إدارة الأحداث وتعزيز تجربة العملاء.",
        },
        {
          id: 3,
          heading: "أدوات تحليل الجمهور",
          text: "الاستفادة من البيانات لفهم تفضيلات الجمهور واتجاهاته، وتحسين استراتيجيات المحتوى وزيادة المشاركة.",
        },
        {
          id: 4,
          heading: "شبكات توزيع المحتوى",
          text: "ضمان تسليم المحتوى بسرعة وموثوقية في جميع أنحاء العالم، مما يعزز تجربة المستخدم ويضمن بثًا عالي الجودة.",
        },
        {
          id: 5,
          heading: "تكامل الواقع المعزز/الواقع الافتراضي (AR/VR)",
          text: "عزز سرد القصص والمشاركة من خلال التقنيات الغامرة، وخلق تجارب لا تُنسى لجمهورك.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برمجيات ترفيهية مبتكرة",
      discription:
        "نحن متخصصون في تقديم حلول برمجيات ترفيهية متطورة تدعم منصات البث، وتبسط إدارة الأحداث، وتدمج تجارب الواقع المعزز/الواقع الافتراضي الغامرة، وتعزز مشاركة الجمهور لتحقيق أداء ورضا أفضل.",
      accordionData: [
        {
          id: "collapseOne",
          title: "منصات البث",
          content:
            "إنشاء منصات سلسة وقابلة للتوسع لبث الفيديو المباشر وعند الطلب، وتقديم تجارب شخصية ومحتوى عالي الجودة لجمهور عالمي.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "حلول إدارة الأحداث",
          content:
            "إدارة الأحداث بكفاءة من إصدار التذاكر وتخصيص المقاعد إلى مشاركة الجمهور، وتبسيط الخدمات اللوجستية وتعزيز تجارب العملاء للحفلات الموسيقية والمهرجانات والمؤتمرات.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "أدوات تحليل الجمهور",
          content:
            "الاستفادة من البيانات لفهم تفضيلات الجمهور، وتعزيز استراتيجيات المحتوى، وتحسين المشاركة من خلال تحليل اتجاهات المشاهدة والسلوك.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "تجارب الواقع المعزز/الواقع الافتراضي (AR/VR)",
          content:
            "دمج تقنيات الواقع المعزز/الواقع الافتراضي الغامرة لإنشاء تجارب ترفيهية فريدة وتفاعلية، وإحداث ثورة في سرد القصص ومشاركة الجمهور.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج الترفيه",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج الترفيه لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "هل يمكنكم المساعدة في بناء منصة بث فيديو قابلة للتوسع؟",
          answer:
            "نعم، نحن متخصصون في إنشاء منصات قوية وقابلة للتوسع لبث الفيديو المباشر وعند الطلب مع ميزات متقدمة مثل توصية المحتوى وبث معدل البت التكيفي.",
        },
        {
          id: "collapseTwo",
          question:
            "كيف تدمجون الواقع المعزز/الواقع الافتراضي في برامج الترفيه؟",
          answer:
            "نقوم بتصميم ودمج تقنيات الواقع المعزز/الواقع الافتراضي لإنشاء تجارب غامرة للألعاب والأحداث المباشرة والجولات الافتراضية، مما يعزز مشاركة المستخدم.",
        },
        {
          id: "collapseThree",
          question: "هل تقدمون أدوات تحليل الجمهور؟",
          answer:
            "بالتأكيد! تساعد أدوات تحليل الجمهور لدينا في تتبع سلوك المستخدم وتفضيلاته ومشاركته، مما يتيح اتخاذ قرارات تستند إلى البيانات لتعزيز أداء منصة الترفيه الخاصة بك.",
        },
        {
          id: "fourth",
          question: "ما نوع حلول إدارة الأحداث التي تقدمونها؟",
          answer:
            "نحن نقدم حلول إدارة الأحداث الشاملة، بما في ذلك أنظمة حجز التذاكر، وتتبع الحضور، وتحليلات ما بعد الحدث.",
        },
        {
          id: "fifth",
          question: "هل تدعم منصاتكم توافق الأجهزة المتعددة؟",
          answer:
            "نعم، تم تحسين حلولنا للأجهزة المحمولة وأجهزة الكمبيوتر المكتبية وأجهزة التلفزيون الذكية، مما يضمن تجربة سلسة عبر جميع الأجهزة.",
        },
        {
          id: "sixth",
          question: "كيف تحمون المحتوى الرقمي من القرصنة؟",
          answer:
            "نحن ننفذ تقنيات إدارة الحقوق الرقمية (DRM) والعلامات المائية لحماية المحتوى الخاص بك ومنع الوصول أو التوزيع غير المصرح به.",
        },
      ],
    },
  },

  {
    id: 10,
    metaTitle: "خدمات تطوير الألعاب | حلول ألعاب غامرة وقابلة للتوسيع",
    metaDes:
      "حوّل أفكار ألعابك إلى واقع مع خدماتنا المتخصصة في تطوير الألعاب. نصمم حلول ألعاب غامرة وقابلة للتطوير لأجهزة الجوال والكمبيوتر الشخصي وأجهزة الألعاب.",
    title: "الألعاب",
    slug: "gaming-entertainment",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "نحن ندعم صناعة الألعاب من خلال تطوير الألعاب المخصصة، ومنصات الاقتصاد داخل اللعبة، وأدوات تحليل اللاعبين، مما يخلق تجارب ألعاب غامرة وآمنة.",
    icon: "/images/industry-gaming-icon.png",
    image: "game.png",
    bannerHeading: "بناء برامج الألعاب",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "gaming-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/gaming.avif)",
    discriptionSection: {
      heading: "أحدث ثورة في صناعة",
      discription:
        "الألعاب، مدفوعة صناعة الألعاب بالتجارب الغامرة والتقنيات المتطورة. في Bitsclan، ننشئ حلول برامج ألعاب تمزج بين الإبداع والتكنولوجيا، وتمكّن مطوري الألعاب والاستوديوهات والناشرين من جذب اللاعبين وإعادة تعريف عوالم الألعاب. من ألعاب الهاتف المحمول إلى منصات الألعاب السحابية، نقدم الابتكار الذي يميز ألعابك.",
      cardHeading: "خبرة في برامج الألعاب",
      cardDiscripiton:
        "طور ألعابًا غامرة متعددة المنصات مع تجارب الواقع المعزز/الواقع الافتراضي، وادمج تقنية البلوك تشين للعب آمن، وقدم حلول ألعاب سحابية للوصول السلس، وقم ببناء أنظمة متعددة اللاعبين في الوقت الفعلي لتجارب لاعبين تفاعلية وجذابة.",
    },
    statsSection: {
      backgroundImage: "game-counter-bg.avif",
      heading: "قُد مستقبل",
      greenPart: "الألعاب الرقمية",
      discription:
        "قيادة الابتكار في الألعاب الذكية من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "الألعاب",
      stats: [
        {
          count: "1,200+",
          text: "لعبة مدعومة بحلولنا",
        },
        {
          count: "700+",
          text: "شركة ألعاب عالمية تم خدمتها",
        },
        {
          count: "98%",
          text: "زيادة في مشاركة اللاعبين",
        },
        {
          count: "95%",
          text: "معدل رضا العملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برمجيات الألعاب",
      text: "أحدث ثورة في أعمالك الترفيهية من خلال حلول برمجية متطورة تعزز بث الفيديو، وتحسن إدارة الأحداث، وتقدم تجارب واقع معزز/واقع افتراضي غامرة لزيادة مشاركة الجمهور.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "تطوير ألعاب متعددة المنصات",
          text: "بناء ألعاب توفر تجارب سلسة عبر منصات الهاتف المحمول ووحدات التحكم وأجهزة الكمبيوتر الشخصية.",
          btnLink: "cross-platform-game-development",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "تطوير ألعاب الواقع المعزز/الواقع الافتراضي (AR/VR)",
          text: "إنشاء عوالم ألعاب غامرة باستخدام الواقع المعزز والواقع الافتراضي لجذب اللاعبين.",
          btnLink: "arvr-game-development",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/arvr-icon.png",
          heading: "حلول الألعاب السحابية",
          text: "تقديم تجارب ألعاب عالية الأداء عبر تقنية السحابة للعب السلس في أي مكان.",
          btnLink: "cloud-gaming-solutions",
          image: "image.png",
        },
        {
          id: 4,
          borderClass: "border-2",
          icon: "/images/blockchain-icon.png",
          heading: "ألعاب البلوك تشين",
          text: "الاستفادة من تقنية البلوك تشين لتطوير أنظمة بيئية ألعاب آمنة ولا مركزية مع ملكية حقيقية.",
          btnLink: "blockchain-gaming",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج الألعاب والامتثال",
      discription:
        "تلتزم حلول الألعاب لدينا بمعايير الصناعة مثل OpenGL و DirectX و Vulkan، مما يضمن أداءً عالي الجودة. كما نضمن الامتثال للوائح خصوصية البيانات مثل اللائحة العامة لحماية البيانات (GDPR) وننفذ آليات مكافحة الغش للحفاظ على اللعب النظيف.",
      image: "game-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برامج الألعاب لدينا",
      discription:
        "اكتشف حلول برامج ترفيهية مبتكرة ومصممة خصيصًا لتقديم بث فيديو سلس، وتحسين إدارة الأحداث، ودمج تجارب الواقع المعزز/الواقع الافتراضي الغامرة لتعزيز مشاركة الجمهور ونجاح الأعمال.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "تكامل محركات الألعاب",
          text: "التكامل بسلاسة مع Unity أو Unreal Engine أو المحركات المخصصة لإنشاء تجارب ألعاب عالية الجودة.",
        },
        {
          id: 2,
          heading: "ألعاب الواقع المعزز/الواقع الافتراضي (AR/VR)",
          text: "بناء عوالم ألعاب غامرة وتفاعلية باستخدام الواقع المعزز والواقع الافتراضي لتجربة لاعب من المستوى التالي.",
        },
        {
          id: 3,
          heading: "حلول ألعاب متعددة اللاعبين",
          text: "تصميم وظائف متعددة اللاعبين في الوقت الفعلي مع الحد الأدنى من زمن الوصول، مما يتيح للاعبين الاتصال والتنافس عالميًا.",
        },
        {
          id: 4,
          heading: "منصات الألعاب السحابية",
          text: "توفير تجارب ألعاب قابلة للتوسع وعالية الأداء من خلال تقنية السحابة، مما يقلل من الاعتماد على الأجهزة.",
        },
        {
          id: 5,
          heading: "أدوات تحقيق الدخل داخل اللعبة",
          text: "دمج أنظمة دفع آمنة وعمليات شراء داخل اللعبة لتوليد الإيرادات وتعزيز تجربة الألعاب.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برمجيات ألعاب مبتكرة",
      discription:
        "نحن متخصصون في تقديم حلول برمجيات ألعاب متطورة تدعم تطوير الألعاب متعددة المنصات، وتعزز تجارب اللاعبين المتعددين، وتدمج تقنيات الواقع المعزز/الواقع الافتراضي الغامرة، وتوفر ألعابًا قائمة على السحابة للاعبين العالميين.",
      accordionData: [
        {
          id: "collapseOne",
          title: "تطوير ألعاب متعددة المنصات",
          content:
            "بناء ألعاب سلسة وقابلة للتوسع تعمل عبر منصات الهاتف المحمول ووحدات التحكم وأجهزة الكمبيوتر الشخصية، مما يضمن تجربة موحدة لجميع اللاعبين.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "ألعاب الواقع المعزز/الواقع الافتراضي (AR/VR)",
          content:
            "تطوير عوالم ألعاب غامرة باستخدام تقنيات الواقع المعزز والواقع الافتراضي، مما يعزز تفاعل اللاعبين ومشاركتهم في بيئات ديناميكية.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "حلول متعددة اللاعبين في الوقت الفعلي",
          content:
            "إنشاء وظائف متعددة اللاعبين في الوقت الفعلي مع الحد الأدنى من زمن الوصول، مما يتيح اللعب السلس عبر الإنترنت وميزات تنافسية عبر المناطق.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "منصات الألعاب السحابية",
          content:
            "تقديم تجارب ألعاب عالية الأداء وقابلة للتوسع عبر تقنية السحابة، مما يقلل من الاعتماد على الأجهزة ويتيح اللعب عند الطلب من أي مكان.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج الألعاب",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج الألعاب لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "هل يمكنكم تطوير ألعاب متعددة المنصات؟",
          answer:
            "نعم، نحن متخصصون في بناء ألعاب متعددة المنصات توفر تجارب سلسة على الهاتف المحمول والكمبيوتر الشخصي ووحدات التحكم.",
        },
        {
          id: "collapseTwo",
          question:
            "كيف تضمنون أن حلول الألعاب قابلة للتوسع لقواعد المستخدمين الكبيرة؟",
          answer:
            "نحن نستخدم تقنيات السحابة والهندسة المعمارية القابلة للتوسع لدعم ملايين اللاعبين المتزامنين دون مشاكل في الأداء.",
        },
        {
          id: "collapseThree",
          question:
            "هل تدمجون تقنيات الواقع المعزز/الواقع الافتراضي في الألعاب؟",
          answer:
            "بالتأكيد! يقوم فريقنا بتصميم وتطوير حلول الألعاب القائمة على الواقع المعزز/الواقع الافتراضي لتزويد اللاعبين بتجارب غامرة وتفاعلية.",
        },
        {
          id: "fourth",
          question: "ما هي أدوات تحقيق الدخل التي تقدمونها لمنصات الألعاب؟",
          answer:
            "نحن نطور أنظمة تحقيق الدخل داخل اللعبة، بما في ذلك المعاملات الدقيقة ونماذج الاشتراك وتكاملات الإعلانات.",
        },
        {
          id: "fifth",
          question: "هل يمكنكم المساعدة في تطوير ألعاب متعددة اللاعبين؟",
          answer:
            "نعم، نحن نبني أنظمة متعددة اللاعبين في الوقت الفعلي بميزات مثل التوفيق بين اللاعبين ولوحات المتصدرين والاتصالات منخفضة زمن الوصول.",
        },
        {
          id: "sixth",
          question: "هل تقدمون أدوات تحليل الألعاب؟",
          answer:
            "نحن نقدم أدوات لتتبع سلوك اللاعبين ومشاركتهم ومقاييس داخل اللعبة، مما يساعد المطورين على اتخاذ قرارات تستند إلى البيانات.",
        },
      ],
    },
  },

  {
    id: 11,
    title: "الشبكات الاجتماعية",
    metaTitle:
      "خدمات تطوير تطبيقات الشبكات الاجتماعية | بناء مجتمعات رقمية تفاعلية",
    metaDes:
      "أنشئ علاقات فعّالة مع خدماتنا لتطوير تطبيقات التواصل الاجتماعي. نبني منصات غنية بالميزات وقابلة للتطوير، تعزز التفاعل وتبني مجتمعات رقمية نابضة بالحياة.",
    slug: "social-networking",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "نحن نقدم منصات اجتماعية مع تحليلات تفاعل المستخدم، وأدوات تعديل المحتوى، وأنظمة إدارة بيانات آمنة، مما يعزز تفاعل المستخدم وخصوصيته.",
    icon: "/images/SocialNetworking.png",
    image: "Social.png",
    bannerHeading: "بناء منصات شبكات اجتماعية مبتكرة",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "social-networking-detail-banner.png",
    backgroundImage:
      "url(/images/industry-detial-banner-bg/SocialNetworking.avif)",
    discriptionSection: {
      heading: "تمكين المجتمعات والاتصالات",
      discription:
        "تعد الشبكات الاجتماعية في صميم كيفية تفاعلنا اليوم، حيث تدفع المحادثات ومشاركة المحتوى والتعاون. في Bitsclan، نحن متخصصون في بناء منصات اجتماعية قوية تعزز التواصل في الوقت الفعلي، ومشاركة المجتمع، ومشاركة المحتوى بسلاسة. سواء كان الأمر يتعلق بإنشاء منصة اجتماعية جديدة أو تحسين منصة موجودة، فإننا نقدم حلولًا تقنية مبتكرة تمكّن المستخدمين من الاتصال والتفاعل بطرق ذات مغزى.",
      cardHeading: "خبرة برامج الشبكات الاجتماعية",
      cardDiscripiton:
        "تعمل حلول برامج الترفيه لدينا على تمكين بناء المجتمع باستخدام أدوات متقدمة لتفاعل المستخدم. نحن نقدم مشاركة محتوى سلسة، ورؤى وسائل التواصل الاجتماعي، وميزات المراسلة الآمنة لتعزيز التواصل ودفع تفاعل الجمهور. تخلق هذه الحلول بيئة ديناميكية ومتصلة تعزز الولاء وتزيد من التفاعل عبر نظامك الأساسي.",
    },
    statsSection: {
      backgroundImage: "social-network-counter-add.avif",
      heading: "قيادة مستقبل",
      greenPart: "الشبكات الاجتماعية",
      discription:
        "قيادة الابتكار في الشبكات الاجتماعية من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "الشبكات الاجتماعية",
      stats: [
        {
          count: "1,000+",
          text: "منصات اجتماعية تم بناؤها",
        },
        {
          count: "500+",
          text: "حلول وسائط اجتماعية عالمية تم تسليمها",
        },
        {
          count: "97%",
          text: "زيادة تفاعل المستخدم",
        },
        {
          count: "98%",
          text: "معدل رضا العملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برامج الشبكات الاجتماعية",
      text: "حوّل أعمال الترفيه الخاصة بك من خلال حلول برمجية مبتكرة ترتقي ببث الفيديو، وتبسط إدارة الأحداث، وتدمج تجارب الواقع المعزز/الواقع الافتراضي الغامرة، مما يدفع مشاركة الجمهور ورضاه بشكل أعمق.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "حلول بناء المجتمع",
          text: "إنشاء ميزات قوية لبناء وإدارة المجتمعات عبر الإنترنت، مما يعزز المشاركة والتفاعل.",
          btnLink: "community-building-solutions",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "حلول المراسلة في الوقت الفعلي",
          text: "تطوير أدوات اتصال آمنة وتفاعلية لتعزيز تفاعلات المستخدم السلسة والجذابة.",
          btnLink: "real-time-messaging-solutions",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/arvr-icon.png",
          heading: "منصات مشاركة المحتوى",
          text: "بناء منصات تمكن المستخدمين من مشاركة مقاطع الفيديو والصور والمحتويات الأخرى بسلاسة، مما يعزز الإبداع والاتصال.",
          btnLink: "content-sharing-platforms",
          image: "image.png",
        },
        {
          id: 4,
          borderClass: "border-2",
          icon: "/images/blockchain-icon.png",
          heading: "أدوات تحليل وسائل التواصل الاجتماعي",
          text: "دمج تحليلات في الوقت الفعلي لتتبع تفاعل المستخدم وتفاعلاته، وتحسين استراتيجيات المحتوى.",
          btnLink: "social-media-analytics-tools",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج الشبكات الاجتماعية والامتثال",
      discription:
        "تتوافق حلول الشبكات الاجتماعية لدينا مع لوائح حماية البيانات العالمية مثل GDPR و CCPA، مما يضمن احترام خصوصية المستخدم. كما نعطي الأولوية لإمكانية الوصول ونتبع معايير الويب لضمان أن منصاتنا سهلة الاستخدام وشاملة.",
      image: "social-network-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برامج الشبكات الاجتماعية لدينا",
      discription:
        "اكتشف حلول برامج الترفيه المبتكرة والمصممة خصيصًا لتقديم بث فيديو سلس، وتحسين إدارة الأحداث، ودمج تجارب الواقع المعزز/الواقع الافتراضي الغامرة لتعزيز مشاركة الجمهور ونجاح الأعمال.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "أدوات مشاركة المجتمع",
          text: "بناء وإدارة مجتمعات نابضة بالحياة بميزات مثل المنتديات والمجموعات وتفاعلات المستخدم لتعزيز المشاركة.",
        },
        {
          id: 2,
          heading: "منصات المراسلة الآمنة",
          text: "تطوير حلول مراسلة مشفرة في الوقت الفعلي لاتصال آمن، مما يضمن خصوصية المستخدم وسلامته.",
        },
        {
          id: 3,
          heading: "تكامل وسائل التواصل الاجتماعي",
          text: "تمكين المستخدمين من ربط حساباتهم عبر منصات اجتماعية مختلفة، مما يسهل مشاركة المحتوى ويعزز التفاعل الاجتماعي.",
        },
        {
          id: 4,
          heading: "أنظمة المحتوى الذي ينشئه المستخدم",
          text: "تمكين المستخدمين من مشاركة المحتوى من خلال أدوات إرسال بسيطة وفعالة، مما يعزز الإبداع ومشاركة المجتمع.",
        },
        {
          id: 5,
          heading: "تحليلات اجتماعية متقدمة",
          text: "تتبع التفاعلات والإعجابات والمشاركات والمقاييس الرئيسية الأخرى لتحسين تفاعل المستخدم واستراتيجيات المحتوى.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برامج شبكات اجتماعية مبتكرة",
      discription:
        "نحن متخصصون في تقديم حلول برامج شبكات اجتماعية متقدمة تمكّن بناء المجتمع، والمراسلة في الوقت الفعلي، ومشاركة المحتوى، وتكامل وسائل التواصل الاجتماعي لتفاعل وتفاعل مستخدمين سلسين.",
      accordionData: [
        {
          id: "collapseOne",
          title: "أدوات مشاركة المجتمع",
          content:
            "بناء وإدارة مجتمعات نابضة بالحياة عبر الإنترنت بميزات مثل المنتديات والمجموعات وتفاعلات المستخدم لتعزيز المشاركة وإنشاء قاعدة مستخدمين مخلصين.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "حلول المراسلة في الوقت الفعلي",
          content:
            "تطوير منصات مراسلة آمنة في الوقت الفعلي باستخدام أدوات اتصال مشفرة لتعزيز خصوصية المستخدم وتفاعله.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "تكامل وسائل التواصل الاجتماعي",
          content:
            "تمكين المستخدمين من ربط حساباتهم عبر منصات اجتماعية مختلفة، مما يسمح بمشاركة المحتوى بسلاسة وتفاعل اجتماعي أفضل.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "أنظمة المحتوى الذي ينشئه المستخدم",
          content:
            "تمكين المستخدمين من إنشاء ومشاركة والمساهمة بالمحتوى من خلال أدوات بسيطة، مما يعزز الإبداع والمنصات التي يحركها المجتمع.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج الشبكات الاجتماعية",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج الشبكات الاجتماعية لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "هل يمكنكم تطوير منصات لبناء المجتمع؟",
          answer:
            "نعم، نحن متخصصون في تطوير المنصات التي تسمح للمستخدمين بإنشاء وإدارة المجتمعات عبر الإنترنت، كاملة مع محادثات جماعية ومنتديات وميزات محتوى من إنشاء المستخدمين.",
        },
        {
          id: "collapseTwo",
          question: "هل تقدمون ميزات المراسلة لتطبيقات الشبكات الاجتماعية؟",
          answer:
            "بالتأكيد! نحن نصمم أنظمة مراسلة آمنة في الوقت الفعلي تسمح للمستخدمين بالدردشة بشكل خاص أو في مجموعات أو مع إمكانيات مشاركة الوسائط.",
        },
        {
          id: "collapseThree",
          question:
            "كيف تدمجون أدوات تحليل وسائل التواصل الاجتماعي في المنصات؟",
          answer:
            "نحن نقدم أدوات تحليل قوية تتتبع تفاعلات المستخدم ومشاركة المحتوى والمقاييس الاجتماعية، مما يتيح لك الحصول على رؤى حول أداء نظامك الأساسي.",
        },
        {
          id: "fourth",
          question:
            "ما نوع الميزات التي يمكنكم تنفيذها للمحتوى الذي ينشئه المستخدمون؟",
          answer:
            "نحن ندمج أدوات للمستخدمين لإنشاء وتحميل ومشاركة المحتوى مثل الصور ومقاطع الفيديو والمقالات، مما يسهل إدارة وعرض مساهمات المستخدمين.",
        },
        {
          id: "fifth",
          question:
            "هل تدعمون تكاملات وسائل التواصل الاجتماعي التابعة لجهات خارجية؟",
          answer:
            "نعم، نحن نمكن تكاملات وسائل التواصل الاجتماعي حتى يتمكن المستخدمون من ربط حساباتهم ومشاركة المحتوى عبر منصات مختلفة، مما يحسن المشاركة والرؤية.",
        },
        {
          id: "sixth",
          question: "هل يمكنكم المساعدة في خصوصية المستخدم وحماية البيانات؟",
          answer:
            "نعم، نحن نلتزم بأحدث قوانين حماية البيانات مثل GDPR ونوفر ميزات مثل تشفير البيانات وإدارة الموافقة لحماية خصوصية مستخدميك.",
        },
      ],
    },
  },

  {
    id: 12,
    title: "الاتصالات",
    slug: "telecom",
    metaTitle: "خدمات تطوير البرمجيات للاتصالات | تمكين الاتصال والابتكار",
    metaDes:
      "عزّز الابتكار في قطاع الاتصالات من خلال خدمات تطوير البرامج لدينا. نقدم حلولًا قابلة للتوسيع لإدارة الشبكات وأنظمة الفوترة وتفاعل العملاء.",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "تتضمن حلول الاتصالات لدينا أنظمة إدارة الفواتير، وأدوات تحسين الشبكة، ومنصات علاقات العملاء، مما يضمن كفاءة العمليات ورضا العملاء.",
    icon: "/images/Telecom.png",
    image: "telecom.png",
    bannerHeading: "غيّر تجارب الاتصالات بحلول متطورة",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "telecom-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/Telecom.avif)",
    discriptionSection: {
      heading: "إحداث ثورة في صناعة",
      discription:
        "الاتصالات، تعد صناعة الاتصالات العمود الفقري للاتصالات العالمية، حيث تربط مليارات الأشخاص في جميع أنحاء العالم. في Bitsclan، نحن متخصصون في بناء حلول برامج اتصالات متقدمة تعزز الاتصال، وتبسط إدارة الشبكة، وتقدم تجارب اتصال من الجيل التالي. من الحلول المستندة إلى السحابة إلى أنظمة شركات الجوال، نساعد شركات الاتصالات على تقديم خدمات عالية الجودة وقابلة للتوسع وآمنة تدفع رضا العملاء ونمو الأعمال.",
      cardHeading: "خبرة برامج الاتصالات",
      cardDiscripiton:
        "نحن نقدم حلول اتصالات متقدمة، بما في ذلك تحسين الشبكة، والأنظمة المستندة إلى السحابة، والفوترة المتنقلة السلسة، وأدوات الاتصال في الوقت الفعلي، وتحليلات البيانات. تساعد خدماتنا شركات الاتصالات على تحسين الأداء وقابلية التوسع وتجربة العملاء من خلال التقنيات المتطورة.",
    },
    statsSection: {
      backgroundImage: "telecom-counter-add.avif",
      heading: "قيادة مستقبل",
      greenPart: "ابتكار الاتصالات",
      discription:
        "قيادة الابتكار في ابتكار الاتصالات من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "ابتكار الاتصالات",
      stats: [
        {
          count: "1,000+",
          text: "حلول اتصالات تم نشرها عالميًا",
        },
        {
          count: "500+",
          text: "مزود خدمة اتصالات تم خدمته",
        },
        {
          count: "98%",
          text: "معدل الاحتفاظ بالعملاء",
        },
        {
          count: "99.99%",
          text: "وقت التشغيل لأنظمة الشبكة",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برامج الاتصالات",
      text: "غيّر أعمال الاتصالات الخاصة بك من خلال حلول برمجية متطورة تعمل على تحسين أداء الشبكة، وتعزيز أدوات الاتصال، وتوفير خدمات آمنة وقابلة للتوسع، مما يضمن تجارب مستخدم سلسة وكفاءة تشغيلية.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "حلول تحسين الشبكة",
          text: "تعزيز كفاءة الشبكة وسرعتها وسعتها من خلال أدوات التحسين الذكية.",
          btnLink: "network-optimization-solutions",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "أنظمة الاتصالات القائمة على السحابة",
          text: "بناء حلول قابلة للتوسع ومصممة للسحابة لإدارة البنية التحتية والخدمات الخاصة بالاتصالات.",
          btnLink: "cloud-based-telecom-systems",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/arvr-icon.png",
          heading: "أنظمة الفوترة والدفع عبر الهاتف المحمول",
          text: "تصميم أنظمة فوترة آمنة وفعالة لمشغلي الهاتف المحمول ومقدمي الخدمات.",
          btnLink: "mobile-billing-and-payment-systems",
          image: "image.png",
        },
        {
          id: 4,
          borderClass: "border-2",
          icon: "/images/blockchain-icon.png",
          heading: "أدوات الاتصال في الوقت الفعلي",
          text: "تطوير أنظمة صوت وفيديو ورسائل سلسة لاتصال محسّن.",
          btnLink: "real-time-communication-tools",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج الاتصالات والامتثال",
      discription:
        "تلتزم حلول الاتصالات لدينا بالمعايير العالمية مثل ETSI و 3GPP و GSMA، مما يضمن قابلية التشغيل البيني عبر الشبكات والأنظمة الأساسية. كما نلتزم بلوائح خصوصية البيانات مثل GDPR و CCPA لحماية بيانات المستخدم وضمان الامتثال التنظيمي.",
      image: "telecom-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول برامج الاتصالات لدينا",
      discription:
        "اكتشف حلول برامج الاتصالات المبتكرة والمصممة خصيصًا لتحسين أداء الشبكة، وتعزيز أدوات الاتصال، وتوفير خدمات آمنة وقابلة للتوسع لتجارب مستخدم سلسة ونجاح الأعمال.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "إدارة شبكة الاتصالات",
          text: "تحسين وإدارة أداء الشبكة عبر مواقع متعددة لضمان تقديم خدمة موثوقة وفعالة.",
        },
        {
          id: 2,
          heading: "أنظمة الفوترة المتنقلة",
          text: "تنفيذ حلول فوترة آمنة وفعالة ودقيقة لتبسيط عمليات مزود خدمة الهاتف المحمول.",
        },
        {
          id: 3,
          heading: "منصات الاتصال السحابية",
          text: "بناء منصات قائمة على السحابة قابلة للتوسع لخدمات الصوت والفيديو والرسائل السلسة، مما يعزز قدرات الاتصال.",
        },
        {
          id: 4,
          heading: "أدوات مشاركة العملاء",
          text: "إنشاء منصات خدمة عملاء تفاعلية باستخدام روبوتات الدردشة، و IVR، والدعم في الوقت الفعلي لتحسين رضا العملاء.",
        },
        {
          id: 5,
          heading: "حلول تحليلات الاتصالات",
          text: "استخدام تحليلات البيانات الضخمة لتعزيز أداء الشبكة وتقديم رؤى قابلة للتنفيذ للعملاء لاتخاذ قرارات أفضل.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برامج اتصالات مبتكرة",
      discription:
        "نحن متخصصون في تقديم حلول برامج اتصالات متطورة تعمل على تحسين أداء الشبكة، وتبسيط أنظمة الفوترة، وتعزيز الاتصالات في الوقت الفعلي، وتسخير تحليلات البيانات للحصول على رؤى أفضل للعملاء.",
      accordionData: [
        {
          id: "collapseOne",
          title: "إدارة شبكة الاتصالات",
          content:
            "إدارة وتحسين أداء الشبكة عبر مواقع متعددة، مما يضمن خدمة موثوقة وعالية الجودة وكفاءة تشغيلية محسّنة.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "أنظمة الفوترة المتنقلة",
          content:
            "تصميم حلول فوترة آمنة وفعالة ودقيقة تلبي احتياجات مزودي خدمة الهاتف المحمول، مما يضمن معالجة دفعات سلسة ورضا العملاء.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "منصات الاتصال السحابية",
          content:
            "بناء منصات قائمة على السحابة قابلة للتوسع لخدمات الصوت والفيديو والرسائل، مما يمكّن مزودي الاتصالات من تقديم حلول اتصال مرنة وعند الطلب.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "حلول تحليلات الاتصالات",
          content:
            "الاستفادة من تحليلات البيانات الضخمة لتتبع وتحسين أداء الشبكة، وتحسين تجارب العملاء، واتخاذ قرارات عمل تعتمد على البيانات.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج الاتصالات",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج الاتصالات لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "هل يمكنكم المساعدة في تحسين شبكات الاتصالات؟",
          answer:
            "نعم، نحن نقدم حلول تحسين الشبكة التي تعزز السرعة والموثوقية والسعة، مما يضمن التشغيل السلس عبر أنظمة الاتصالات.",
        },
        {
          id: "collapseTwo",
          question: "كيف تضمنون أمان أنظمة الاتصالات؟",
          answer:
            "نحن ندمج ميزات أمان متقدمة مثل التشفير والمصادقة متعددة العوامل واكتشاف الاحتيال لحماية أنظمة الاتصالات من التهديدات واختراقات البيانات.",
        },
        {
          id: "collapseThree",
          question: "ما هي البنية التحتية للاتصالات القائمة على السحابة؟",
          answer:
            "تستخدم البنية التحتية للاتصالات القائمة على السحابة السحابة لتقديم خدمات اتصالات قابلة للتوسع وعند الطلب، مما يسمح لمزودي الاتصالات بتقليل التكاليف وزيادة المرونة.",
        },
        {
          id: "fourth",
          question: "هل تقدمون حلول فوترة متنقلة؟",
          answer:
            "نعم، نحن نصمم أنظمة فوترة متنقلة آمنة وفعالة وقادرة على التعامل مع كميات كبيرة من المعاملات لمزودي الاتصالات.",
        },
        {
          id: "fifth",
          question: "هل يمكنكم دمج التحليلات في أنظمة الاتصالات؟",
          answer:
            "بالتأكيد! نحن نقدم أدوات تحليل البيانات التي تساعد شركات الاتصالات على تحسين أداء شبكاتها، وتتبع أنماط الاستخدام، والحصول على رؤى حول سلوك العملاء.",
        },
        {
          id: "sixth",
          question: "هل تقدمون حلولاً لمشاركة العملاء؟",
          answer:
            "نعم، نحن نقدم حلولًا مثل روبوتات الدردشة وأنظمة الرد الصوتي التفاعلي (IVR) ومنصات المراسلة في الوقت الفعلي التي تعزز خدمة العملاء ومشاركتهم.",
        },
      ],
    },
  },

  {
    id: 13,
    title: "الطاقة",
    metaTitle:
      "خدمات تطوير البرمجيات لقطاع الطاقة | تعزيز التحول الرقمي في مجال الطاقة",
    metaDes:
      "سرّع الابتكار في قطاع الطاقة من خلال حلول البرمجيات المخصصة لدينا. نطور أدوات لإدارة الطاقة والشبكات الذكية وكفاءة العمليات.",
    slug: "energy",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "نحن نقدم أنظمة إدارة الشبكات الذكية، ومنصات تحسين الموارد، وحلول تداول آمنة تعزز الكفاءة والامتثال في قطاع الطاقة.",
    icon: "/images/Energy.png",
    image: "energy.png",
    bannerHeading: "تغذية المستقبل بحلول الطاقة المستدامة",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "energy-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/Energy.avif)",
    discriptionSection: {
      heading: "قيادة المسؤولية في",
      discription:
        "ابتكار الطاقة، يتطور قطاع الطاقة بسرعة مع الدفع العالمي نحو الاستدامة والكفاءة وحلول الطاقة المتجددة. في Bitsclan، نمكّن مزودي الطاقة من خلال حلول برمجية متطورة تبسط إنتاج الطاقة وتوزيعها واستهلاكها. سواء كان الأمر يتعلق بإدارة الطاقة المتجددة، أو الشبكات الذكية، أو تحليلات الطاقة، فإننا نساعد الشركات في قطاع الطاقة على تحسين العمليات وتقليل الهدر وتحقيق أهداف الاستدامة.",
      cardHeading: "خبرة برامج الطاقة",
      cardDiscripiton:
        "نحن نقدم حلول طاقة مبتكرة لتحسين الكفاءة والاستدامة. تعمل حلول الشبكة الذكية لدينا على تعزيز موثوقية الشبكة والمراقبة في الوقت الفعلي. تعمل إدارة الطاقة المتجددة على دمج وإدارة المصادر المتجددة، بينما توفر تحليلات استهلاك الطاقة رؤى لتقليل التكاليف. من خلال الفوترة والتقارير الآلية، نقوم بتبسيط العمليات المالية، وتساعد حلول كفاءة الطاقة لدينا الشركات على تقليل النفايات وتحسين الأداء.",
    },
    statsSection: {
      backgroundImage: "energy-counter-bg.avif",
      heading: "تمكين قطاع",
      greenPart: "الطاقة بالتكنولوجيا",
      discription:
        "قيادة الابتكار في ابتكار الطاقة من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "الطاقة",
      stats: [
        {
          count: "1,500+",
          text: "حلول طاقة تم نشرها عالميًا",
        },
        {
          count: "250+",
          text: "مزود خدمة طاقة تم خدمته",
        },
        {
          count: "98%",
          text: "معدل رضا العملاء",
        },
        {
          count: "75%",
          text: "تقليل هدر الطاقة للعملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برامج الطاقة",
      text: "حوّل أعمال الطاقة الخاصة بك من خلال حلول برمجية مبتكرة تعمل على تحسين إدارة الطاقة، وتعزيز الكفاءة، وتوفير خدمات قابلة للتوسع وآمنة، مما يدفع التميز التشغيلي والاستدامة.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "حلول الشبكة الذكية",
          text: "إنشاء شبكات ذكية ومؤتمتة لتوزيع الطاقة بكفاءة وتقليل وقت التوقف عن العمل.",
          btnLink: "smart-grid-solutions",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "إدارة الطاقة المتجددة",
          text: "تطوير أنظمة لإدارة مصادر الطاقة المتجددة مثل الطاقة الشمسية وطاقة الرياح والطاقة الكهرومائية.",
          btnLink: "renewable-energy-management",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/arvr-icon.png",
          heading: "تحليلات استهلاك الطاقة",
          text: "الاستفادة من البيانات الضخمة لتحسين استهلاك الطاقة عبر الصناعات وتحسين الكفاءة.",
          btnLink: "energy-consumption-analytics",
          image: "image.png",
        },
        {
          id: 4,
          borderClass: "border-2",
          icon: "/images/blockchain-icon.png",
          heading: "الفوترة والتقارير الآلية",
          text: "إنشاء أنظمة فوترة آلية لدفعات استهلاك الطاقة دقيقة وفي الوقت المناسب.",
          btnLink: "automated-billing-and-reporting",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج الطاقة والامتثال",
      discription:
        "تتوافق حلول برامج الطاقة لدينا مع لوائح ومعايير الصناعة، مثل ISO 50001 و ANSI و IEEE، مما يضمن أن عملياتك تلبي أفضل الممارسات العالمية. بالإضافة إلى ذلك، تم تصميم أنظمتنا للالتزام باللوائح البيئية، مما يساعدك على تحقيق أهداف الاستدامة.",
      image: "energy-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول الطاقة لدينا",
      discription:
        "اكتشف حلول الطاقة المتطورة المصممة لتحسين توزيع الموارد، وتعزيز كفاءة الطاقة، وتوفير أنظمة آمنة وقابلة للتوسع لنمو الأعمال المستدام والنجاح التشغيلي.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "إدارة الشبكة الذكية",
          text: "تحسين أداء الشبكة من خلال المراقبة في الوقت الفعلي والأتمتة والتحليلات التنبؤية لتعزيز الكفاءة والموثوقية.",
        },
        {
          id: 2,
          heading: "تكامل الطاقة المتجددة",
          text: "دمج مصادر الطاقة المتجددة مثل الطاقة الشمسية وطاقة الرياح بسلاسة في شبكتك الحالية لاستخدام الطاقة بكفاءة واستدامة.",
        },
        {
          id: 3,
          heading: "تحليلات وتوقعات الطاقة",
          text: "اكتساب رؤى قابلة للتنفيذ حول أنماط استهلاك الطاقة، وتوقع الطلب المستقبلي، وتحسين تخصيص الموارد لتحقيق أقصى قدر من الكفاءة.",
        },
        {
          id: 4,
          heading: "أنظمة الاستجابة للطلب",
          text: "تنفيذ أنظمة تدير استهلاك الطاقة ديناميكيًا بناءً على الطلب في الوقت الفعلي، مما يمنع التحميل الزائد على الشبكة ويعزز الموثوقية.",
        },
        {
          id: 5,
          heading: "حلول كفاءة الطاقة",
          text: "تحديد واستغلال الفرص لتقليل هدر الطاقة وتحسين الكفاءة التشغيلية، مما يدفع الاستدامة وتوفير التكاليف.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برامج طاقة مبتكرة",
      discription:
        "نحن متخصصون في تقديم حلول برامج طاقة متقدمة تعمل على تحسين أداء الشبكة، ودمج الطاقة المتجددة، وتبسيط تحليلات الطاقة، وتعزيز أنظمة الاستجابة للطلب لاستخدام الطاقة المستدام والفعال.",
      accordionData: [
        {
          id: "collapseOne",
          title: "إدارة الشبكة الذكية",
          content:
            "تحسين أداء الشبكة من خلال المراقبة في الوقت الفعلي والأتمتة والتحليلات التنبؤية لتعزيز توزيع الطاقة وتقليل وقت التوقف عن العمل وتحسين الكفاءة التشغيلية.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "تكامل الطاقة المتجددة",
          content:
            "دمج مصادر الطاقة المتجددة بسلاسة، مثل الطاقة الشمسية وطاقة الرياح، في أنظمة الشبكة الحالية لزيادة كفاءة الطاقة واستدامتها.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "تحليلات وتوقعات الطاقة",
          content:
            "الاستفادة من البيانات الضخمة والتحليلات المتقدمة لاكتساب رؤى حول أنماط استخدام الطاقة، وتوقع المتطلبات المستقبلية، وتحسين تخصيص الموارد لعمليات فعالة من حيث التكلفة.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "أنظمة الاستجابة للطلب",
          content:
            "تنفيذ أنظمة لإدارة الطلب على الطاقة في الوقت الفعلي، ومنع التحميل الزائد على الشبكة وضمان استخدام طاقة مستقر وفعال خلال أوقات الذروة.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج الطاقة",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج الطاقة لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "كيف يمكنكم المساعدة في تقليل استهلاك الطاقة في عملياتنا؟",
          answer:
            "نحن نقدم حلول تحليلات الطاقة التي تحدد الأنماط في استهلاك الطاقة، مما يتيح لك تحسين الاستخدام وتقليل الهدر وتحسين الكفاءة عبر عملياتك.",
        },
        {
          id: "collapseTwo",
          question: "ما هي الشبكات الذكية وكيف تعمل؟",
          answer:
            "الشبكات الذكية هي شبكات كهربائية متقدمة تستخدم البيانات في الوقت الفعلي والأتمتة لتحسين توزيع الطاقة. يمكنها اكتشاف المشكلات في الشبكة، وتقليل وقت التوقف عن العمل، وتمكين استخدام أكثر كفاءة للطاقة من خلال موازنة العرض والطلب.",
        },
        {
          id: "collapseThree",
          question: "كيف يمكن دمج الطاقة المتجددة في أنظمتنا الحالية؟",
          answer:
            "نحن نطور حلول تكامل سلسة تسمح بتوصيل مصادر الطاقة المتجددة مثل الطاقة الشمسية وطاقة الرياح والطاقة الكهرومائية بكفاءة إلى البنية التحتية للطاقة الحالية لديك، مما يساعدك على تحقيق أهداف الاستدامة مع الحفاظ على استقرار الشبكة.",
        },
        {
          id: "fourth",
          question: "ما هي تحليلات استهلاك الطاقة؟",
          answer:
            "تستخدم تحليلات استهلاك الطاقة البيانات لتحليل أنماط استخدام الطاقة وتحديد مجالات التحسين. توفر حلولنا رؤى قابلة للتنفيذ لتقليل الاستهلاك والتكاليف، مما يعزز الكفاءة التشغيلية الشاملة.",
        },
        {
          id: "fifth",
          question:
            "هل يمكن لحلولكم المساعدة في كفاءة الطاقة في العمليات الصناعية؟",
          answer:
            "نعم، تم تصميم حلول كفاءة الطاقة لدينا لتحسين استخدام الطاقة عبر الأنظمة الصناعية. من خلال الاستفادة من التحليلات التنبؤية والأتمتة، نساعد الشركات على تقليل الهدر وتقليل بصمتها الكربونية.",
        },
        {
          id: "sixth",
          question: "هل تقدمون حلولاً لإدارة الاستجابة للطلب في أنظمة الطاقة؟",
          answer:
            "نعم، نحن نقدم أنظمة الاستجابة للطلب التي تدير استخدام الطاقة خلال أوقات ذروة الطلب، مما يمنع التحميل الزائد على الشبكة ويضمن استخدام الطاقة بكفاءة عند الحاجة إليها بشدة.",
        },
      ],
    },
  },

  {
    id: 14,
    title: "الزراعة",
    metaTitle:
      "خدمات تطوير البرمجيات لقطاع الزراعة | زراعة حلول الزراعة الذكية",
    metaDes:
      "حوّل الزراعة من خلال خدمات تطوير برامج الزراعة الخاصة بنا. نقدم حلولاً ذكية لإدارة المحاصيل، والزراعة الدقيقة، وتحسين سلسلة التوريد.",
    slug: "agriculture",
    content:
      "لوريم إيبسوم هو ببساطة نص شكلي لصناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم النص الشكلي القياسي للصناعة منذ القرن الخامس عشر، عندما أخذت طابعة غير معروفة مجموعة من الأحرف وخلطتها لتصنع كتابًا عينيًا.",
    description:
      "نحن نزرع الابتكار في الزراعة بتقنيات الزراعة الدقيقة، ومراقبة المحاصيل المدعومة بالذكاء الاصطناعي، وسلاسل التوريد المؤمنة بتقنية البلوك تشين، مما يضمن عوائد أعلى وممارسات مستدامة.",
    icon: "/images/industries-icons/Agriculture.svg",
    image: "Agriculture.avif",
    bannerHeading: "تغذية المستقبل بحلول طاقة مستدامة",
    bannerBtnText: "هيا بنا نبدأ",
    bannerImage: "energy-detail-banner.png",
    backgroundImage: "url(/images/industry-detial-banner-bg/Energy.avif)",
    discriptionSection: {
      heading: "قيادة المسؤولية في",
      discription:
        "ابتكار الطاقة، يتطور قطاع الطاقة بسرعة مع الدفع العالمي نحو الاستدامة والكفاءة وحلول الطاقة المتجددة. في Bitsclan، نمكّن مزودي الطاقة من خلال حلول برمجية متطورة تبسط إنتاج الطاقة وتوزيعها واستهلاكها. سواء كان الأمر يتعلق بإدارة الطاقة المتجددة، أو الشبكات الذكية، أو تحليلات الطاقة، فإننا نساعد الشركات في قطاع الطاقة على تحسين العمليات وتقليل الهدر وتحقيق أهداف الاستدامة.",
      cardHeading: "خبرة برامج الطاقة",
      cardDiscripiton:
        "نحن نقدم حلول طاقة مبتكرة لتحسين الكفاءة والاستدامة. تعمل حلول الشبكة الذكية لدينا على تعزيز موثوقية الشبكة والمراقبة في الوقت الفعلي. تعمل إدارة الطاقة المتجددة على دمج وإدارة المصادر المتجددة، بينما توفر تحليلات استهلاك الطاقة رؤى لتقليل التكاليف. من خلال الفوترة والتقارير الآلية، نقوم بتبسيط العمليات المالية، وتساعد حلول كفاءة الطاقة لدينا الشركات على تقليل النفايات وتحسين الأداء.",
    },
    statsSection: {
      backgroundImage: "energy-counter-bg.avif",
      heading: "تمكين قطاع",
      greenPart: "الطاقة بالتكنولوجيا",
      discription:
        "قيادة الابتكار في ابتكار الطاقة من خلال حلول برمجية متقدمة لتجارب تعلم محسنة.",
      subheading: "أفضل شركة استشارية في مجال",
      greenPartSubHeading: "الطاقة",
      stats: [
        {
          count: "1,500+",
          text: "حلول طاقة تم نشرها عالميًا",
        },
        {
          count: "250+",
          text: "مزود خدمة طاقة تم خدمته",
        },
        {
          count: "98%",
          text: "معدل رضا العملاء",
        },
        {
          count: "75%",
          text: "تقليل هدر الطاقة للعملاء",
        },
      ],
    },
    industryServices: {
      heading: "خدمات تطوير برامج الطاقة",
      text: "حوّل أعمال الطاقة الخاصة بك من خلال حلول برمجية مبتكرة تعمل على تحسين إدارة الطاقة، وتعزيز الكفاءة، وتوفير خدمات قابلة للتوسع وآمنة، مما يدفع التميز التشغيلي والاستدامة.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          heading: "حلول الشبكة الذكية",
          text: "إنشاء شبكات ذكية ومؤتمتة لتوزيع الطاقة بكفاءة وتقليل وقت التوقف عن العمل.",
          btnLink: "smart-grid-solutions",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          heading: "إدارة الطاقة المتجددة",
          text: "تطوير أنظمة لإدارة مصادر الطاقة المتجددة مثل الطاقة الشمسية وطاقة الرياح والطاقة الكهرومائية.",
          btnLink: "renewable-energy-management",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/arvr-icon.png",
          heading: "تحليلات استهلاك الطاقة",
          text: "الاستفادة من البيانات الضخمة لتحسين استهلاك الطاقة عبر الصناعات وتحسين الكفاءة.",
          btnLink: "energy-consumption-analytics",
          image: "image.png",
        },
        {
          id: 4,
          borderClass: "border-2",
          icon: "/images/blockchain-icon.png",
          heading: "الفوترة والتقارير الآلية",
          text: "إنشاء أنظمة فوترة آلية لدفعات استهلاك الطاقة دقيقة وفي الوقت المناسب.",
          btnLink: "automated-billing-and-reporting",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading: "معايير برامج الطاقة والامتثال",
      discription:
        "تتوافق حلول برامج الطاقة لدينا مع لوائح ومعايير الصناعة، مثل ISO 50001 و ANSI و IEEE، مما يضمن أن عملياتك تلبي أفضل الممارسات العالمية. بالإضافة إلى ذلك، تم تصميم أنظمتنا للالتزام باللوائح البيئية، مما يساعدك على تحقيق أهداف الاستدامة.",
      image: "energy-add.avif",
    },
    softwareSolutions: {
      heading: "استكشف حلول الطاقة لدينا",
      discription:
        "اكتشف حلول الطاقة المتطورة المصممة لتحسين توزيع الموارد، وتعزيز كفاءة الطاقة، وتوفير أنظمة آمنة وقابلة للتوسع لنمو الأعمال المستدام والنجاح التشغيلي.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "إدارة الشبكة الذكية",
          text: "تحسين أداء الشبكة من خلال المراقبة في الوقت الفعلي والأتمتة والتحليلات التنبؤية لتعزيز الكفاءة والموثوقية.",
        },
        {
          id: 2,
          heading: "تكامل الطاقة المتجددة",
          text: "دمج مصادر الطاقة المتجددة مثل الطاقة الشمسية وطاقة الرياح بسلاسة في شبكتك الحالية لاستخدام الطاقة بكفاءة واستدامة.",
        },
        {
          id: 3,
          heading: "تحليلات وتوقعات الطاقة",
          text: "اكتساب رؤى قابلة للتنفيذ حول أنماط استهلاك الطاقة، وتوقع الطلب المستقبلي، وتحسين تخصيص الموارد لتحقيق أقصى قدر من الكفاءة.",
        },
        {
          id: 4,
          heading: "أنظمة الاستجابة للطلب",
          text: "تنفيذ أنظمة تدير استهلاك الطاقة ديناميكيًا بناءً على الطلب في الوقت الفعلي، مما يمنع التحميل الزائد على الشبكة ويعزز الموثوقية.",
        },
        {
          id: 5,
          heading: "حلول كفاءة الطاقة",
          text: "تحديد واستغلال الفرص لتقليل هدر الطاقة وتحسين الكفاءة التشغيلية، مما يدفع الاستدامة وتوفير التكاليف.",
        },
      ],
    },
    industryExpertise: {
      heading: "خبرتنا: حلول برامج طاقة مبتكرة",
      discription:
        "نحن متخصصون في تقديم حلول برامج طاقة متقدمة تعمل على تحسين أداء الشبكة، ودمج الطاقة المتجددة، وتبسيط تحليلات الطاقة، وتعزيز أنظمة الاستجابة للطلب لاستخدام الطاقة المستدام والفعال.",
      accordionData: [
        {
          id: "collapseOne",
          title: "إدارة الشبكة الذكية",
          content:
            "تحسين أداء الشبكة من خلال المراقبة في الوقت الفعلي والأتمتة والتحليلات التنبؤية لتعزيز توزيع الطاقة وتقليل وقت التوقف عن العمل وتحسين الكفاءة التشغيلية.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "تكامل الطاقة المتجددة",
          content:
            "دمج مصادر الطاقة المتجددة بسلاسة، مثل الطاقة الشمسية وطاقة الرياح، في أنظمة الشبكة الحالية لزيادة كفاءة الطاقة واستدامتها.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "تحليلات وتوقعات الطاقة",
          content:
            "الاستفادة من البيانات الضخمة والتحليلات المتقدمة لاكتساب رؤى حول أنماط استخدام الطاقة، وتوقع المتطلبات المستقبلية، وتحسين تخصيص الموارد لعمليات فعالة من حيث التكلفة.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "أنظمة الاستجابة للطلب",
          content:
            "تنفيذ أنظمة لإدارة الطلب على الطاقة في الوقت الفعلي، ومنع التحميل الزائد على الشبكة وضمان استخدام طاقة مستقر وفعال خلال أوقات الذروة.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "الأسئلة الشائعة حول تطوير برامج الطاقة",
      discription:
        "إليك إجابات لبعض الأسئلة الأكثر شيوعًا حول خدمات تطوير برامج الطاقة لدينا:",
      faqData: [
        {
          id: "collapseOne",
          question: "كيف يمكنكم المساعدة في تقليل استهلاك الطاقة في عملياتنا؟",
          answer:
            "نحن نقدم حلول تحليلات الطاقة التي تحدد الأنماط في استهلاك الطاقة، مما يتيح لك تحسين الاستخدام وتقليل الهدر وتحسين الكفاءة عبر عملياتك.",
        },
        {
          id: "collapseTwo",
          question: "ما هي الشبكات الذكية وكيف تعمل؟",
          answer:
            "الشبكات الذكية هي شبكات كهربائية متقدمة تستخدم البيانات في الوقت الفعلي والأتمتة لتحسين توزيع الطاقة. يمكنها اكتشاف المشكلات في الشبكة، وتقليل وقت التوقف عن العمل، وتمكين استخدام أكثر كفاءة للطاقة من خلال موازنة العرض والطلب.",
        },
        {
          id: "collapseThree",
          question: "كيف يمكن دمج الطاقة المتجددة في أنظمتنا الحالية؟",
          answer:
            "نحن نطور حلول تكامل سلسة تسمح بتوصيل مصادر الطاقة المتجددة مثل الطاقة الشمسية وطاقة الرياح والطاقة الكهرومائية بكفاءة إلى البنية التحتية للطاقة الحالية لديك، مما يساعدك على تحقيق أهداف الاستدامة مع الحفاظ على استقرار الشبكة.",
        },
        {
          id: "fourth",
          question: "ما هي تحليلات استهلاك الطاقة؟",
          answer:
            "تستخدم تحليلات استهلاك الطاقة البيانات لتحليل أنماط استخدام الطاقة وتحديد مجالات التحسين. توفر حلولنا رؤى قابلة للتنفيذ لتقليل الاستهلاك والتكاليف، مما يعزز الكفاءة التشغيلية الشاملة.",
        },
        {
          id: "fifth",
          question:
            "هل يمكن لحلولكم المساعدة في كفاءة الطاقة في العمليات الصناعية؟",
          answer:
            "نعم، تم تصميم حلول كفاءة الطاقة لدينا لتحسين استخدام الطاقة عبر الأنظمة الصناعية. من خلال الاستفادة من التحليلات التنبؤية والأتمتة، نساعد الشركات على تقليل الهدر وتقليل بصمتها الكربونية.",
        },
        {
          id: "sixth",
          question: "هل تقدمون حلولاً لإدارة الاستجابة للطلب في أنظمة الطاقة؟",
          answer:
            "نعم، نحن نقدم أنظمة الاستجابة للطلب التي تدير استخدام الطاقة خلال أوقات ذروة الطلب، مما يمنع التحميل الزائد على الشبكة ويضمن استخدام الطاقة بكفاءة عند الحاجة إليها بشدة.",
        },
      ],
    },
  },
];

export const similerBannerDataAr = {
  mainHeading: "إعادة تصور الصناعة بالتقنيات الرائدة",
  content:
    "بغض النظر عن مجالك، نحن شركاؤك الموثوقون في بناء حلول تكنولوجية متقدمة وحديثة.",
  btnText2: "حدد موعدًا لاستشارة!",
};

export const pioneerChangeSectionContentArabic = {
  mainHeading: "خبرتنا عبر",
  greenHeading: "الصناعات الرئيسية",
  sectionDescription:
    "في بيتسكلان، نحن لا نخدم الصناعات فحسب - بل نحولها. من خلال الاستفادة من أحدث التقنيات وخبرتنا العميقة، ننشئ حلولًا مخصصة تعالج التحديات الفريدة التي تواجهها الشركات في مختلف القطاعات. من ريادة التحول الرقمي في الصناعات التقليدية إلى تمكين مستقبل التقنيات الذكية، مهمتنا هي إحداث تغيير ذي معنى.",
};

export const hireContactIndustriesSectionContentAr = {
  mainHeading: "الصناعات التي نخدمها بالمواهب الخبيرة و",
  greenHeading: "الحلول المخصصة",
  sectionDescription:
    "تمتد خبرتنا في تطوير تطبيقات الهاتف المحمول عبر مجموعة واسعة من الصناعات، مقدمين حلولًا مخصصة تلبي المتطلبات الفريدة لكل قطاع.",
};

export const slidesDataArabic = {
  mainHeading: "تجربة ميزة Bitsclan",
  sectionDescription:
    "لا نكتفي بتقديم الخدمات فحسب، بل نخلق قيمة مستدامة لأعمالك. نهجنا مبني على خبرة عميقة وتقنيات متطورة والتزام راسخ بالتميز. باختيارك Bitsclan، فإنك تختار شريكًا ملتزمًا بنجاحك.",
  industryPageSliderData: [
    {
      heading: "خبرة عبر الصناعات",
      text: "بفضل خبرتنا الواسعة في قطاعات متنوعة، نقدم معرفة خاصة بالصناعة تدفع الحلول المصممة خصيصًا، مما يضمن أننا نلبي تحدياتك الفريدة بدقة.",
    },
    {
      heading: "تقنيات متطورة",
      text: "نحن نستفيد من أحدث التقنيات، من الذكاء الاصطناعي والبلوك تشين إلى التحليلات المتقدمة، مما يضمن أن عملك يستفيد من حلول مبتكرة فعالة ومستقبلية.",
    },
    {
      heading: "نهج يركز على العميل",
      text: "نجاحك هو أولويتنا. نأخذ الوقت الكافي لفهم عملك، وتقديم استراتيجيات مخصصة تتوافق مع أهدافك وتقدم نتائج قابلة للقياس.",
    },
    {
      heading: "وصول عالمي بفهم محلي",
      text: "مع وجود عالمي ورؤى محلية عميقة، نقدم حلولًا تتناسب مع سوقك، مما يضمن الملاءمة والفعالية في كل منطقة تعمل فيها.",
    },
    {
      heading: "الابتكار في الصميم",
      text: "نحن مدفوعون بشغف الابتكار، ونستكشف باستمرار التقنيات والمنهجيات الجديدة لضمان أننا نقدم حلولًا ليست حديثة فحسب، بل متقدمة.",
    },
  ],
};

export var mainBannerImg = {
  backgroundImage: `url(/images/what-we-do/industy-page-box.avif)`,
};

export const staticHeadingArabic = {
  brandsBoxHeading: "كثيرون يحبوننا، والبعض الآخر يعتمد علينا في نجاحهم",
  bookAnAppointment: "حجز موعد",
  getStarted: "ابدأ",
  talktoExpert: "تحدث إلى الخبير",
};

export const industriesContentArabic = {
  heading: "ريادة التغيير عبر الصناعات",
  description:
    "قيادة الابتكار وتحويل القطاعات من خلال الحلول المتطورة والرؤى الحديثة.",
  buttonText: "اعرف المزيد",
  buttonLink: "/Industries",
  cards: [
    {
      title: "الرعاية الصحية",
      cls: "ind-blue",
      icon: "/images/heart.png",
      slug: "healthcare",
    },
    {
      title: "التكنولوجيا المالية",
      cls: "ind-indigo",
      icon: "/images/Fintech.png",
      slug: "fintech",
    },
    {
      title: "التجزئة والتجارة الإلكترونية",
      cls: "ind-purple",
      icon: "/images/ecommerce-icon.png",
      slug: "retail-ecommerce",
    },
    {
      title: "العقارات",
      cls: "ind-violet",
      icon: "/images/RealEstate.png",
      slug: "real-estate",
    },
    {
      title: "صناعة السيارات",
      cls: "ind-sky",
      icon: "/images/automotive-icon.png",
      slug: "automotive-logistics",
    },
    {
      title: "التعليم",
      cls: "ind-royal",
      icon: "/images/education-icon.png",
      slug: "education",
    },
    {
      title: "التأمين",
      cls: "ind-sky",
      icon: "/images/Insurance.png",
      slug: "insurance",
    },
    {
      title: "الخدمات اللوجستية",
      cls: "ind-royal",
      icon: "/images/logistics.avif",
      slug: "logistics",
    },
    {
      title: "الترفيه",
      cls: "ind-sky",
      icon: "/images/entertainment.avif",
      slug: "entertainment",
    },
  ],
};

export default tabDataArabic;
